const mgmt = {
  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.projects': 'Projects',
  'nav.instructions': 'Instructions',
  'nav.dailyLog': 'Daily Log',
  'nav.alerts': 'Alerts',
  'nav.newProject': 'New Project',
  'nav.management': 'Management',
  'nav.logout': 'Sign out',
  'nav.menu': 'Menu',
  'nav.actions': 'Actions',

  // Language switcher
  'lang.en': 'EN',
  'lang.ja': 'JP',
  'lang.zh': '中文',
  'lang.label': 'Language',

  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.subtitle': 'Project Control Panel',
  'dashboard.projectControl': 'Project Control',
  'dashboard.activeProjects': 'Active Projects',
  'dashboard.completed': 'Completed',
  'dashboard.onHold': 'On Hold',
  'dashboard.planning': 'Planning',
  'dashboard.allProjects': 'All Projects',
  'dashboard.inProgressNow': 'In progress now',
  'dashboard.fullyFinished': 'Fully finished',
  'dashboard.blockedProjects': 'Blocked projects',
  'dashboard.notYetStarted': 'Not yet started',
  'dashboard.viewAll': 'View all',
  'dashboard.manage': 'Manage',
  'dashboard.noProjects': 'No projects yet',
  'dashboard.createFirst': 'Create your first project to get started',
  'dashboard.createFirstProject': 'Create First Project',
  'dashboard.noActiveProjects': 'No active projects',
  'dashboard.createProject': 'Create a project',
  'dashboard.moreProjects': '+{count} more projects',

  // Project statuses
  'status.active': 'Active',
  'status.planning': 'Planning',
  'status.onHold': 'On Hold',
  'status.complete': 'Complete',
  'status.completed': 'Completed',
  'status.closed': 'Closed',
  'status.draft': 'Draft',
  'status.sent': 'Sent',
  'status.pending': 'Pending',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.inProgress': 'In Progress',
  'status.notStarted': 'Not Started',
  'status.delayed': 'Delayed',

  // Projects page
  'projects.title': 'Projects',
  'projects.search': 'Search projects, clients, addresses...',
  'projects.noAddress': 'No address set',
  'projects.noClient': 'No client set',
  'projects.noAddressShort': 'No address',
  'projects.noProjectsFound': 'No projects found',
  'projects.tryAdjusting': 'Try adjusting your search or filters',
  'projects.noMatchFilter': 'No projects match this filter',
  'projects.clearSearch': 'Clear search',
  'projects.loadingProjects': 'Loading projects...',
  'projects.project': 'project',
  'projects.projects': 'projects',
  'projects.matching': 'matching',
  'projects.schedFinal': 'Sched',
  'projects.clFinal': 'CL',

  // Project detail tabs
  'tabs.overview': 'Overview',
  'tabs.stages': 'Stages',
  'tabs.schedule': 'Schedule',
  'tabs.checklist': 'Checklist',
  'tabs.photos': 'Photos',
  'tabs.files': 'Files',
  'tabs.tasks': 'Tasks',
  'tabs.notifications': 'Notifications',
  'tabs.questions': 'Questions',
  'tabs.dailyLog': 'Daily Log',
  'tabs.instructions': 'Instructions',
  'tabs.payments': 'Payments',
  'tabs.more': 'More',

  // Project detail overview
  'overview.projectDetails': 'Project Details',
  'overview.client': 'Client',
  'overview.type': 'Type',
  'overview.startDate': 'Start Date',
  'overview.estCompletion': 'Est. Completion',
  'overview.status': 'Status',
  'overview.currentStage': 'Current Stage',
  'overview.projectProgress': 'Project Progress',
  'overview.scheduleFinal': 'Schedule Final',
  'overview.checklistFinal': 'Checklist Final',
  'overview.pendingScheduleItems': 'Pending Schedule Items',
  'overview.description': 'Description',
  'overview.files': 'Files',
  'overview.schedule': 'Schedule',
  'overview.recalculateProgress': 'Recalculate Project Progress',
  'overview.editProject': 'Edit Project',
  'overview.projectSettings': 'Project Settings',

  // Progress / stats
  'progress.projectProgress': 'Project Progress',
  'progress.management': 'Management',
  'progress.subcontractor': 'Subcontractor',
  'progress.stage': 'Stage',
  'progress.loading': 'Loading...',
  'progress.done': 'Done',
  'progress.pending': 'Pending',
  'progress.waitingForSub': 'Waiting for sub checks',
  'progress.scheduleHealth': 'Schedule Health',
  'progress.reviewPendingSchedule': 'Review Pending Schedule',
  'progress.pendingScheduleItems': '{count} schedule items pending',
  'progress.checklistItemsPending': '{count} checklist items pending',
  'progress.scheduleFormula': 'Schedule Final {sched}% × 50% + Checklist Final {cl}% × 50% = {total}% Project Progress',
  'progress.mgmtChecksComplete': 'Management checks complete. Waiting for subcontractor checks.',
  'progress.subPendingDesc': '{remaining} of {total} subcontractor-required checklist items are still pending subcontractor confirmation.',
  'progress.viewPendingItems': 'View Pending Items',

  // Notifications
  'notifications.title': 'Notifications',
  'notifications.allNotifications': 'All Notifications',
  'notifications.projectNotifications': 'Project Notifications',
  'notifications.markAllRead': 'Mark all read',
  'notifications.noNotifications': 'No notifications',
  'notifications.allCaughtUp': "You're all caught up",
  'notifications.loading': 'Loading notifications...',
  'notifications.justNow': 'just now',
  'notifications.minAgo': '{n} min ago',
  'notifications.hrAgo': '{n} hr ago',
  'notifications.hrsAgo': '{n} hrs ago',
  'notifications.dayAgo': '{n} day ago',
  'notifications.daysAgo': '{n} days ago',

  // Questions
  'questions.clientQuestions': 'Client Questions',
  'questions.unanswered': 'unanswered',
  'questions.noQuestions': 'No questions yet',
  'questions.clientQuestionsAppear': 'Client questions will appear here',
  'questions.managementReply': 'Management Reply',
  'questions.typeReply': 'Type your reply...',
  'questions.sendReply': 'Send Reply',

  // Instructions
  'instructions.title': 'Instructions',
  'instructions.subtitle': 'Manage and track instructions sent to subcontractors',
  'instructions.newInstruction': 'New Instruction',
  'instructions.changeOrder': 'Change Order',
  'instructions.reload': 'Reload',
  'instructions.total': 'Total',
  'instructions.open': 'Open',
  'instructions.changeOrders': 'Change Orders',
  'instructions.completed': 'Completed',
  'instructions.closed': 'Closed',
  'instructions.allProjects': 'All Projects',
  'instructions.allPriorities': 'All Priorities',
  'instructions.allStatuses': 'All',
  'instructions.sent': 'Sent',
  'instructions.inProgress': 'In Progress',
  'instructions.noInstructions': 'No instructions found',
  'instructions.createInstruction': 'Create an instruction to send to subcontractors',
  'instructions.createChangeOrder': 'Create Change Order',
  'instructions.createFirstInstruction': 'Create First Instruction',
  'instructions.to': 'To',
  'instructions.due': 'Due',
  'instructions.highPriority': 'High Priority',
  'instructions.responseRequired': 'Response Required',
  'instructions.readMore': 'Read more',
  'instructions.showLess': 'Show less',
  'instructions.managementNote': 'Management Note',
  'instructions.markCompleted': 'Mark Completed',
  'instructions.markClosed': 'Mark Closed',
  'instructions.viewInProject': 'View in Project',
  'instructions.unassigned': 'Unassigned',
  'instructions.items': 'items',
  'instructions.instruction': 'Instruction',
  'instructions.internalDraft': 'Internal / Draft',
  'instructions.subcontractor': 'Subcontractor',
  'instructions.clientLabel': 'Client',
  'instructions.reasonForChange': 'Reason for Change',
  'instructions.currentFinish': 'Current Finish',
  'instructions.newFinish': 'New Finish',
  'instructions.costImpact': 'Cost Impact',
  'instructions.scheduleImpact': 'Schedule Impact',
  'instructions.requiresClientApproval': 'Requires client approval',
  'instructions.clientApproved': 'Client Approved',
  'instructions.clientRejected': 'Client Rejected',

  // Daily Log
  'dailyLog.title': 'Daily Log Review',
  'dailyLog.createDailyLog': 'Create Daily Log',
  'dailyLog.internalOnly': 'Internal Only',
  'dailyLog.shareWithClient': 'Share with Client',
  'dailyLog.publishedToClient': 'Published to client',
  'dailyLog.selectPhotos': 'Select photos',
  'dailyLog.managementComment': 'Management Comment',
  'dailyLog.internalNote': 'Internal note',
  'dailyLog.pendingReview': 'Pending Review',
  'dailyLog.approvedForClient': 'Approved for Client',
  'dailyLog.internalOnlyBadge': 'Internal Only',
  'dailyLog.rejected': 'Rejected',
  'dailyLog.allStatuses': 'All Statuses',
  'dailyLog.allProjects': 'All Projects',
  'dailyLog.allStages': 'All Stages',
  'dailyLog.allSubcontractors': 'All Subcontractors',
  'dailyLog.filters': 'Filters',
  'dailyLog.showAll': 'Show all',
  'dailyLog.hide': 'Hide',
  'dailyLog.pending': 'pending',
  'dailyLog.approve': 'Approve',
  'dailyLog.internal': 'Internal',
  'dailyLog.reject': 'Reject',
  'dailyLog.instruction': 'Instruction',
  'dailyLog.noPhotosMatch': 'No photos match your filters',
  'dailyLog.tryAdjusting': 'Try adjusting your filters',
  'dailyLog.noPhotosYet': 'No daily log photos uploaded yet',
  'dailyLog.selected': 'selected',
  'dailyLog.approveForClient': 'Approve for Client',
  'dailyLog.keepInternal': 'Keep Internal',
  'dailyLog.clearSelection': 'Clear selection',
  'dailyLog.apply': 'Apply',
  'dailyLog.applying': 'Applying...',
  'dailyLog.cancel': 'Cancel',
  'dailyLog.optionalNote': 'Optional note...',
  'dailyLog.removePhoto': 'Remove this photo?',
  'dailyLog.removePhotoDesc': 'The photo will be marked as deleted. This cannot be undone.',
  'dailyLog.remove': 'Remove',
  'dailyLog.managementNoteLabel': 'Management Note',
  'dailyLog.addNote': 'Add a note about this photo...',
  'dailyLog.saveNote': 'Save Note',
  'dailyLog.clientVisible': 'Client Visible',
  'dailyLog.selectAll': 'Select all',
  'dailyLog.deselectAll': 'Deselect all',
  'dailyLog.titleRequired': 'Title *',
  'dailyLog.titlePlaceholder': 'e.g. Foundation work progress — 11 May',
  'dailyLog.visibility': 'Visibility',
  'dailyLog.photosSelected': '{count} photo(s) selected will be included in this Daily Log.',
  'dailyLog.creating': 'Creating...',
  'dailyLog.retry': 'Retry',
  'dailyLog.reset': 'Reset',

  // Photos tab
  'photos.title': 'Photo Gallery',
  'photos.upload': 'Upload',
  'photos.noPhotos': 'No photos yet',
  'photos.uploadToDocument': 'Upload photos to document this project',
  'photos.loadingPhotos': 'Loading photos...',
  'photos.deletePhoto': 'Delete this photo?',
  'photos.cannotBeUndone': 'This cannot be undone.',
  'photos.deleting': 'Deleting...',
  'photos.delete': 'Delete',
  'photos.cancel': 'Cancel',
  'photos.uploadPhotos': 'Upload Photos',
  'photos.openPreview': 'Open preview',

  // Files tab
  'files.title': 'Project Files',
  'files.upload': 'Upload',
  'files.folder': 'Folder',
  'files.recentFiles': 'Recent Files',
  'files.allFiles': 'All Files',
  'files.total': 'total',
  'files.all': 'All',
  'files.visible': 'Visible',
  'files.hidden': 'Hidden',
  'files.noFiles': 'No files yet',
  'files.uploadToGetStarted': 'Upload files to get started',
  'files.uploadToFolder': 'Upload files to this folder',
  'files.newFolder': 'New Folder',
  'files.folderName': 'Folder Name',
  'files.folderNamePlaceholder': 'e.g. Plans, Invoices, Contracts...',
  'files.createFolder': 'Create Folder',
  'files.loadingFiles': 'Loading files...',
  'files.openFile': 'Open File',
  'files.deleteFile': 'Delete file',
  'files.hideFile': 'Hide',
  'files.showFile': 'Show',
  'files.uploadFiles': 'Upload Files',

  // Schedule tab
  'schedule.title': 'Schedule',
  'schedule.scheduleFinal': 'Schedule Final',
  'schedule.checklistFinal': 'Checklist Final',
  'schedule.projectProgress': 'Project Progress',
  'schedule.pendingItems': 'Pending items',
  'schedule.complete': 'Complete',
  'schedule.completed': 'Completed',
  'schedule.notMapped': 'Not mapped',
  'schedule.noChecklistMapped': 'No checklist mapped',
  'schedule.manualComplete': 'Manual complete',
  'schedule.criticalItems': 'Critical items',
  'schedule.delayedItems': 'Delayed items',
  'schedule.atRiskItems': 'At risk items',
  'schedule.scheduleHealth': 'Schedule Health',
  'schedule.reviewPendingSchedule': 'Review Pending Schedule',
  'schedule.markAllPendingComplete': 'Mark All Pending Complete',
  'schedule.recalculateProgress': 'Recalculate Project Progress',
  'schedule.noScheduleYet': 'No schedule has been created yet',
  'schedule.createFromTemplate': 'Create schedule from Development template',
  'schedule.scheduleItemsNeedDates': 'Schedule items need dates',
  'schedule.generateInitialTimeline': 'Generate initial timeline',
  'schedule.noItemsMatchFilter': 'No schedule items match the current filter.',
  'schedule.clearFilters': 'Clear filters',
  'schedule.retry': 'Retry',
  'schedule.refreshing': 'Refreshing schedule data...',
  'schedule.markAllConfirmTitle': 'Mark All Pending Complete?',
  'schedule.markAllConfirmDesc': 'This will mark {count} schedule items as complete with Final 100% progress.',
  'schedule.markAllWarning': 'This action cannot be undone easily.',
  'schedule.marking': 'Marking...',
  'schedule.markComplete': 'Mark {count} Complete',
  'schedule.cancel': 'Cancel',
  'schedule.recalcCriticalPath': 'Recalculate Critical Path?',
  'schedule.recalcDesc': 'This will compute the critical path from the current schedule items and links.',
  'schedule.recalcWarning': 'Critical path alerts will be enabled after recalculation.',
  'schedule.calculating': 'Calculating...',
  'schedule.recalcAndSave': 'Recalculate & Save',
  'schedule.setupInProgress': 'Schedule imported. Setup in progress.',
  'schedule.setupDesc': 'Complete checklist mapping and progress tracking before relying on critical path alerts.',
  'schedule.pendingCount': '{count} pending',
  'schedule.scheduleComplete': 'Schedule complete',
  'schedule.showDetails': 'Show details',
  'schedule.hideDetails': 'Hide details',
  'schedule.reviewPendingItems': 'Review pending items',
  'schedule.noChecklistMapping': 'No Checklist Mapping',
  'schedule.incompleteChecklist': 'Incomplete Checklist',
  'schedule.calculatedFrom': 'Calculated from 50% Checklist + 50% Schedule',

  // Checklist tab
  'checklist.title': 'Checklist',
  'checklist.managementCheck': 'Management Check',
  'checklist.subcontractorCheck': 'Subcontractor Check',
  'checklist.finalApproval': 'Final Approval',
  'checklist.required': 'Required',
  'checklist.checked': 'Checked',
  'checklist.unchecked': 'Unchecked',
  'checklist.fullyApproved': 'Fully Approved',
  'checklist.waitManagement': 'Wait Mgmt',
  'checklist.waitSubcontractor': 'Wait Sub',
  'checklist.unmapped': 'Unmapped',
  'checklist.allStages': 'All Stages',
  'checklist.allScheduleItems': 'All Schedule Items',
  'checklist.byStage': 'By Stage',
  'checklist.bySection': 'By Section',
  'checklist.noChecklistItems': 'No checklist items',
  'checklist.createChecklist': 'Create Checklist',
  'checklist.createChecklistDesc': 'Create a checklist to track project milestones, inspections, and sign-offs.',
  'checklist.loadingChecklist': 'Loading checklist...',
  'checklist.failedToLoad': 'Failed to load checklist',
  'checklist.retry': 'Retry',
  'checklist.unmappedItems': 'Unmapped Checklist Items',
  'checklist.unmappedDesc': 'These items are not linked to any schedule item. Map them to organize your checklist.',
  'checklist.map': 'Map',
  'checklist.cancel': 'Cancel',
  'checklist.selectSchedule': 'Select schedule...',
  'checklist.allChecked': 'All checklist items are checked. Great work!',
  'checklist.viewChecked': 'View checked items',
  'checklist.noItemsMatch': 'No checklist items match the current filters.',
  'checklist.showAll': 'Show all items',
  'checklist.mgmtDone': 'Mgmt Done',
  'checklist.completeMgmt': 'Complete Mgmt',
  'checklist.subDone': 'Sub Done',
  'checklist.completeSub': 'Complete Sub',
  'checklist.finalComplete': 'Final: Complete',
  'checklist.waitingForSub': 'Waiting for Subcontractor',
  'checklist.waitingForMgmt': 'Waiting for Management',
  'checklist.requestAction': 'Request Action',
  'checklist.refreshing': 'Refreshing checklist data...',
  'checklist.noMappedItems': 'No checklist items mapped to {stage}',
  'checklist.noMappedDesc': 'This stage has no linked checklist items yet.',
  'checklist.unmappedCount': '{count} unmapped checklist items',
  'checklist.progress': '{stage} Progress',
  'checklist.managementDone': 'Management: Done',
  'checklist.managementPending': 'Management: Pending',
  'checklist.subcontractorDone': 'Subcontractor: Done',
  'checklist.subcontractorPending': 'Subcontractor: Pending',

  // Stages tab
  'stages.title': 'Stages',
  'stages.noScheduleItems': 'No schedule items yet',
  'stages.createScheduleFirst': 'Create a schedule from the Schedule tab to see stages linked with checklist items.',
  'stages.failedToLoad': 'Failed to load stages',
  'stages.retry': 'Retry',
  'stages.suggestedStage': 'Suggested current stage',
  'stages.updateProjectStage': 'Update project stage',
  'stages.updateStageTitle': 'Update Project Stage',
  'stages.updateStageConfirm': 'Are you sure you want to move this project to {stage}?',
  'stages.updateStageDesc': "This will update the project's current stage based on schedule completion.",
  'stages.cancel': 'Cancel',
  'stages.current': 'Current',
  'stages.scheduleComplete': 'schedule complete',
  'stages.schedule': 'schedule',
  'stages.checklistFinal': 'checklist final',
  'stages.noChecklistMapped': 'No checklist mapped — schedule only',
  'stages.combinedProgress': 'Stage Progress (Combined)',
  'stages.checklistFinalApproval': 'Checklist Final Approval',
  'stages.paymentMilestones': 'Payment Milestones',
  'stages.backToAll': 'Back to all Construction items',
  'stages.oneOrMoreDelayed': 'One or more items delayed',
  'stages.notMapped': 'Not mapped to checklist — counts as complete',
  'stages.checklistComplete': 'Checklist complete',
  'stages.checklistIncomplete': 'Checklist incomplete',
  'stages.manuallyCompleted': 'Manually completed',
  'stages.manual': 'Manual {pct}% — no checklist',

  // Tasks tab
  'tasks.title': 'Tasks',
  'tasks.open': 'Open',
  'tasks.overdue': 'Overdue',
  'tasks.total': 'Total',
  'tasks.all': 'All',
  'tasks.decision': 'Decision',
  'tasks.payment': 'Payment',
  'tasks.completed': 'Completed',
  'tasks.newTask': 'New',
  'tasks.noTasks': 'No tasks',
  'tasks.createTask': 'Create a task to get started',
  'tasks.noTasksAssigned': 'No tasks assigned yet',
  'tasks.loadingTasks': 'Loading tasks...',
  'tasks.taskType': 'Task Type',
  'tasks.assignTo': 'Assign To',
  'tasks.dueDate': 'Due Date',
  'tasks.description': 'Description',
  'tasks.options': 'Options',
  'tasks.invoiceNo': 'Invoice No.',
  'tasks.amount': 'Amount ($)',
  'tasks.paymentDueDate': 'Payment Due Date',
  'tasks.creating': 'Creating...',
  'tasks.createTask2': 'Create Task',
  'tasks.title2': 'Title *',
  'tasks.titlePlaceholder': 'e.g. Tile Selection Required',
  'tasks.descPlaceholder': 'Describe what needs to be done...',
  'tasks.addOption': '+ Add Option',
  'tasks.optionLabel': 'Option label',
  'tasks.optionDesc': 'Description (optional)',
  'tasks.priceNote': 'Price note (optional)',
  'tasks.invoicePlaceholder': 'e.g. PC-003',
  'tasks.amountPlaceholder': 'e.g. 35000',
  'tasks.selectThisOption': 'Select this option',
  'tasks.selectionConfirmed': 'Selection confirmed',
  'tasks.respond': 'Respond',
  'tasks.typeResponse': 'Type your response...',
  'tasks.submitResponse': 'Submit Response',
  'tasks.markAsPaid': 'Mark as Paid',
  'tasks.paymentRef': 'Payment reference / transaction ID',
  'tasks.paymentNote': 'Note (optional)',
  'tasks.confirmPayment': 'Confirm Payment Received',
  'tasks.close': 'Close',
  'tasks.due': 'Due',
  'tasks.options2': 'options',
  'tasks.selected': 'Selected',
  'tasks.invoiceDetails': 'Invoice Details',
  'tasks.paymentStatus': 'Payment Status',
  'tasks.reference': 'Reference',
  'tasks.response': 'Response',

  // New Project wizard
  'newProject.title': 'New Project',
  'newProject.projectInfo': 'Project Information',
  'newProject.basicDetails': 'Basic details about the project',
  'newProject.projectName': 'Project Name',
  'newProject.projectNamePlaceholder': 'e.g. Henderson Renovation',
  'newProject.siteAddress': 'Site Address',
  'newProject.siteAddressPlaceholder': 'e.g. 42 Bethells Rd, Henderson, Auckland',
  'newProject.clientName': 'Client Name',
  'newProject.clientNamePlaceholder': 'e.g. Yamamoto Family',
  'newProject.projectDescription': 'Project Description',
  'newProject.descPlaceholder': 'Brief description of the project scope...',
  'newProject.projectType': 'Project Type',
  'newProject.selectType': 'Select the type of construction project',
  'newProject.scheduleSetup': 'Schedule Setup',
  'newProject.coverPhoto': 'Cover Photo',
  'newProject.teamAccess': 'Team Access',
  'newProject.stages': 'Construction Stages',
  'newProject.overallSchedule': 'Overall Project Schedule',
  'newProject.paymentSchedule': 'Payment Schedule',
  'newProject.reviewCreate': 'Review & Create',
  'newProject.continue': 'Continue',
  'newProject.back': 'Back',
  'newProject.createProject': 'Create Project',
  'newProject.creatingProject': 'Creating project...',
  'newProject.viewProject': 'View Project',
  'newProject.projectCreated': 'Project created successfully!',
  'newProject.startDate': 'Project Start Date',
  'newProject.estCompletion': 'Estimated Completion',
  'newProject.subcontractor': 'Subcontractor',
  'newProject.client': 'Client',
  'newProject.optional': '(optional)',
  'newProject.emailAddress': 'Email Address',
  'newProject.contactName': 'Contact Name',
  'newProject.company': 'Company',
  'newProject.fullName': 'Full Name',
  'newProject.selectStages': 'Select the stages that apply to this project',
  'newProject.stagesSelected': '{count} stage(s) selected',
  'newProject.reviewDetails': 'Confirm all details before creating the project',
  'newProject.projectDetails': 'Project Details',
  'newProject.scheduleSetupLabel': 'Schedule Setup',
  'newProject.stagesLabel': 'Stages',
  'newProject.teamLabel': 'Team',
  'newProject.paymentScheduleLabel': 'Payment Schedule',
  'newProject.noPaymentSchedule': 'No payment schedule — can be added later from Edit Project',
  'newProject.readyToCreate': 'Ready to create this project?',
  'newProject.uniqueCode': 'A unique project code will be generated automatically.',

  // Edit Project
  'editProject.title': 'Edit Project',
  'editProject.basicInfo': 'Basic Info',
  'editProject.typeCover': 'Type & Cover',
  'editProject.stages': 'Stages',
  'editProject.schedule': 'Schedule',
  'editProject.payments': 'Payments',
  'editProject.saveChanges': 'Save Changes',
  'editProject.savingChanges': 'Saving changes...',
  'editProject.changesSaved': 'Changes saved successfully',
  'editProject.projectName': 'Project Name',
  'editProject.siteAddress': 'Site Address',
  'editProject.clientName': 'Client Name',
  'editProject.projectDescription': 'Project Description',
  'editProject.projectType': 'Project Type',
  'editProject.coverPhoto': 'Cover Photo',
  'editProject.constructionStages': 'Construction Stages',
  'editProject.addNewStage': 'Add New Stage',
  'editProject.stageName': 'Stage name...',
  'editProject.add': 'Add',
  'editProject.completion': 'Completion',
  'editProject.planned': 'Planned',
  'editProject.actual': 'Actual',
  'editProject.start': 'Start',
  'editProject.end': 'End',
  'editProject.delayReason': 'Delay Reason',
  'editProject.delayReasonPlaceholder': 'Describe the reason for the delay...',
  'editProject.overallSchedule': 'Overall Project Schedule',
  'editProject.startDate': 'Project Start Date',
  'editProject.estCompletion': 'Estimated Completion',
  'editProject.resetToDefault': 'Reset to default cover',
  'editProject.coverUrlPlaceholder': 'https://... (leave blank for default)',

  // Common buttons
  'btn.save': 'Save',
  'btn.cancel': 'Cancel',
  'btn.delete': 'Delete',
  'btn.edit': 'Edit',
  'btn.upload': 'Upload',
  'btn.download': 'Download',
  'btn.submit': 'Submit',
  'btn.send': 'Send',
  'btn.continue': 'Continue',
  'btn.back': 'Back',
  'btn.close': 'Close',
  'btn.reload': 'Reload',
  'btn.review': 'Review',
  'btn.filter': 'Filter',
  'btn.search': 'Search',
  'btn.reset': 'Reset',
  'btn.confirm': 'Confirm',
  'btn.markComplete': 'Mark Complete',
  'btn.markResolved': 'Mark Resolved',
  'btn.markClosed': 'Mark Closed',
  'btn.newProject': 'New Project',
  'btn.newInstruction': 'New Instruction',
  'btn.changeOrder': 'Change Order',
  'btn.sendInstruction': 'Send Instruction',
  'btn.saveDraft': 'Save Draft',
  'btn.assignSubcontractor': 'Assign Subcontractor',
  'btn.tryAgain': 'Try again',
  'btn.retry': 'Retry',
  'btn.new': 'New',
  'btn.apply': 'Apply',
  'btn.dismiss': 'Dismiss',
  'btn.updateStage': 'Update project stage',

  // Forms
  'form.projectName': 'Project name',
  'form.address': 'Address',
  'form.client': 'Client',
  'form.type': 'Type',
  'form.startDate': 'Start date',
  'form.estCompletion': 'Estimated completion',
  'form.status': 'Status',
  'form.priority': 'Priority',
  'form.dueDate': 'Due date',
  'form.title': 'Title',
  'form.message': 'Message',
  'form.description': 'Description',
  'form.attachment': 'Attachment',
  'form.uploadFile': 'Upload file',
  'form.uploadPhoto': 'Upload photo',
  'form.selectProject': 'Select project',
  'form.selectSubcontractor': 'Select subcontractor',
  'form.selectClient': 'Select client',
  'form.required': '*',

  // Errors / empty states
  'error.noDataFound': 'No data found',
  'error.noProjectsFound': 'No projects found',
  'error.noInstructionsYet': 'No instructions yet',
  'error.noSubcontractorsAssigned': 'No subcontractors assigned',
  'error.couldNotLoadData': 'Could not load data',
  'error.uploadFailed': 'Upload failed',
  'error.saveFailed': 'Save failed',
  'error.pleaseTryAgain': 'Please try again',
  'error.areYouSure': 'Are you sure?',
  'error.cannotBeUndone': 'This action cannot be undone',
  'error.projectNotFound': 'Project not found',
  'error.backToProjects': 'Back to projects',
  'error.failedToLoad': 'Failed to load',

  // Logout
  'logout.signOut': 'Sign out?',
  'logout.signOutDesc': 'You will be signed out of JPH Portal.',
  'logout.cancel': 'Cancel',
  'logout.signOutBtn': 'Sign out',

  // User menu
  'user.management': 'Management',
  'user.jphPortal': 'JPH Portal',
  'user.producedBy': 'Produced by Japan Homes Group',

  // Change password
  'password.changeTitle': 'Change Password',
  'password.current': 'Current password',
  'password.new': 'New password',
  'password.confirmNew': 'Confirm new password',
  'password.cancel': 'Cancel',
  'password.save': 'Update password',
  'password.changeSuccess': 'Password updated successfully',
  'password.changeSuccessHint': 'Your password has been changed. You can continue using the portal, or sign in again with your new password if prompted on another device.',
  'password.signInAgain': 'Sign in again',
  'password.continue': 'Continue',
  'nav.changePassword': 'Change Password',

  // Status labels (for DB values → display)
  'statusLabel.active': 'Active',
  'statusLabel.planning': 'Planning',
  'statusLabel.on_hold': 'On Hold',
  'statusLabel.complete': 'Complete',
  'statusLabel.completed': 'Complete',
  'statusLabel.closed': 'Closed',
  'statusLabel.draft': 'Draft',
  'statusLabel.sent': 'Sent',
  'statusLabel.seen': 'Seen',
  'statusLabel.in_progress': 'In Progress',
  'statusLabel.replied': 'Replied',
  'statusLabel.pending': 'Pending',
  'statusLabel.approved': 'Approved',
  'statusLabel.rejected': 'Rejected',
  'statusLabel.unknown': 'Unknown',
  'statusLabel.unassigned': 'Unassigned',
  'statusLabel.unknown_project': 'Unknown Project',

  // Checklist inline labels
  'checklist.managementDoneShort': 'Mgmt Done',
  'checklist.completeMgmtShort': 'Complete Mgmt',
  'checklist.subDoneShort': 'Sub Done',
  'checklist.completeSubShort': 'Complete Sub',
  'checklist.finalCompleteShort': 'Final: Complete',
  'checklist.waitingForSubShort': 'Waiting for Subcontractor',
  'checklist.waitingForMgmtShort': 'Waiting for Management',
  'checklist.requestActionShort': 'Request Action',
  'checklist.checksLabel': 'checks',
  'checklist.finalApprovalLabel': 'Final Approval',
  'checklist.completedLabel': 'Completed',
  'checklist.requiredLabel': 'Required',
  'checklist.unmappedLabel': 'Unmapped',
  'checklist.noChecklistMappedScheduleOnly': 'No checklist mapped — schedule only',
  'checklist.allItemsChecked': 'All checklist items are checked. Great work!',
  'checklist.noItemsMatchFilters': 'No checklist items match the current filters.',
  'checklist.noItemsMatchFilter': 'No checklist items match the current filter.',
  'checklist.showAllItems': 'Show all items',
  'checklist.viewCheckedItems': 'View checked items',
  'checklist.unmappedItemsCount': '{count} unmapped',
  'checklist.noScheduleItemsInStage': 'No schedule items in this stage',
  'checklist.finalApprovalComplete': 'Final approval is complete only when all required approvals (management + subcontractor) are complete.',
  'checklist.waitingForSubChecks': 'Waiting for subcontractor checks',
  'checklist.refreshingData': 'Refreshing checklist data...',
  'checklist.loadingText': 'Loading checklist...',
  'checklist.failedToLoadText': 'Failed to load checklist',
  'checklist.createChecklistBtn': 'Create Checklist',
  'checklist.allConstructionSubStages': 'All Construction Sub-Stages',
  'checklist.allStagesOption': 'All Stages',
  'checklist.allScheduleItemsOption': 'All Schedule Items',
  'checklist.byStageOption': 'By Stage',
  'checklist.bySectionOption': 'By Section',
  'checklist.selectScheduleOption': 'Select schedule...',
  'checklist.mapBtn': 'Map',
  'checklist.cancelBtn': 'Cancel',
  'checklist.unmappedItemsTitle': 'Unmapped Checklist Items',
  'checklist.unmappedItemsDesc': 'These items are not linked to any schedule item. Map them to organize your checklist.',

  // Tasks inline labels
  'tasks.openLabel': 'Open',
  'tasks.overdueLabel': 'Overdue',
  'tasks.totalLabel': 'Total',
  'tasks.noTasksLabel': 'No tasks',
  'tasks.createTaskLabel': 'Create a task to get started',
  'tasks.noTasksAssignedLabel': 'No tasks assigned yet',
  'tasks.loadingTasksLabel': 'Loading tasks...',
  'tasks.newTaskBtn': 'New',
  'tasks.createTaskBtn': 'Create Task',
  'tasks.creatingLabel': 'Creating...',
  'tasks.closeBtn': 'Close',
  'tasks.dueLabel': 'Due',
  'tasks.optionsCountLabel': 'options',
  'tasks.selectedLabel': 'Selected',
  'tasks.invoiceDetailsLabel': 'Invoice Details',
  'tasks.paymentStatusLabel': 'Payment Status',
  'tasks.referenceLabel': 'Reference',
  'tasks.responseLabel': 'Response',
  'tasks.respondLabel': 'Respond',
  'tasks.typeResponseLabel': 'Type your response...',
  'tasks.submitResponseBtn': 'Submit Response',
  'tasks.markAsPaidBtn': 'Mark as Paid',
  'tasks.paymentRefLabel': 'Payment reference / transaction ID',
  'tasks.paymentNoteLabel': 'Note (optional)',
  'tasks.confirmPaymentBtn': 'Confirm Payment Received',
  'tasks.selectThisOptionBtn': 'Select this option',
  'tasks.selectionConfirmedLabel': 'Selection confirmed',
  'tasks.addOptionBtn': '+ Add Option',
  'tasks.optionLabelLabel': 'Option label',
  'tasks.optionDescLabel': 'Description (optional)',
  'tasks.priceNoteLabel': 'Price note (optional)',
  'tasks.titleLabel': 'Title *',
  'tasks.titlePlaceholderLabel': 'e.g. Tile Selection Required',
  'tasks.descPlaceholderLabel': 'Describe what needs to be done...',
  'tasks.invoicePlaceholderLabel': 'e.g. PC-003',
  'tasks.amountPlaceholderLabel': 'e.g. 35000',
  'tasks.taskTypeLabel': 'Task Type',
  'tasks.assignToLabel': 'Assign To',
  'tasks.dueDateLabel': 'Due Date',
  'tasks.descriptionLabel': 'Description',
  'tasks.optionsLabel2': 'Options',
  'tasks.invoiceNoLabel': 'Invoice No.',
  'tasks.amountLabel': 'Amount ($)',
  'tasks.paymentDueDateLabel': 'Payment Due Date',
  'tasks.newTaskTitle': 'New Task',

  // Stages inline labels
  'stages.currentLabel': 'Current',
  'stages.scheduleCompleteLabel': 'schedule complete',
  'stages.scheduleLabel': 'schedule',
  'stages.checklistFinalLabel': 'checklist final',
  'stages.noChecklistMappedLabel': 'No checklist mapped — schedule only',
  'stages.combinedProgressLabel': 'Stage Progress (Combined)',
  'stages.checklistFinalApprovalLabel': 'Checklist Final Approval',
  'stages.paymentMilestonesLabel': 'Payment Milestones',
  'stages.backToAllLabel': 'Back to all Construction items',
  'stages.oneOrMoreDelayedLabel': 'One or more items delayed',
  'stages.notMappedLabel': 'Not mapped to checklist — counts as complete',
  'stages.checklistCompleteLabel': 'Checklist complete',
  'stages.checklistIncompleteLabel': 'Checklist incomplete',
  'stages.manuallyCompletedLabel': 'Manually completed',
  'stages.manualLabel': 'Manual {pct}% — no checklist',
  'stages.noScheduleItemsInStage': 'No schedule items in this stage',
  'stages.checksLabel': 'checks',
  'stages.checklistItemsLabel': 'checklist items',
  'stages.completedLabel': 'completed',
  'stages.delayedLabel': 'Delayed',
  'stages.atRiskLabel': 'At Risk',
  'stages.completeLabel': 'Complete',
  'stages.mgmtPendingLabel': 'mgmt pending',
  'stages.subPendingLabel': 'sub pending',
  'stages.showingItemsLabel': 'Showing items',
  'stages.updateStageBtn': 'Update Stage',
  'stages.cancelBtn': 'Cancel',
  'stages.suggestedCurrentStageLabel': 'Suggested current stage',
  'stages.scheduleProgressSuggestsMoving': 'Schedule progress suggests moving this project to {stage}.',
  'stages.updateProjectStageBtn': 'Update project stage',
  'stages.dismissBtn': 'Dismiss',
  'stages.failedToLoadStages': 'Failed to load stages',
  'stages.retryBtn': 'Retry',
  'stages.noScheduleItemsYet': 'No schedule items yet',
  'stages.createScheduleFromTab': 'Create a schedule from the Schedule tab to see stages linked with checklist items.',
  'stages.formulaLabel': 'Formula: Sched {sched}% x 50% + CL {cl}% x 50% = {combined}%',
  'stages.nilPayment': 'NIL',

  // Schedule inline labels
  'schedule.refreshingData': 'Refreshing schedule data...',
  'schedule.loadingText': 'Loading...',
  'schedule.retryBtn': 'Retry',
  'schedule.dismissBtn': 'Dismiss',
  'schedule.updateProjectStageBtn': 'Update project stage',
  'schedule.scheduleProgressSuggestsMoving': 'Schedule progress suggests moving this project to {stage}.',
  'schedule.checklistFinalLabel': 'Checklist Final',
  'schedule.scheduleFinalLabel': 'Schedule Final',
  'schedule.projectProgressLabel': 'Project Progress',
  'schedule.calculatedFrom50': 'Calculated from 50% Checklist + 50% Schedule',
  'schedule.pendingCountLabel': '{count} pending',
  'schedule.scheduleCompleteLabel': 'Schedule complete',
  'schedule.showDetailsBtn': 'Show details',
  'schedule.hideDetailsBtn': 'Hide details',
  'schedule.reviewPendingItemsBtn': 'Review pending items',
  'schedule.noChecklistMappingBtn': 'No Checklist Mapping',
  'schedule.incompleteChecklistBtn': 'Incomplete Checklist',
  'schedule.markAllPendingBtn': 'Mark all pending schedule items complete',
  'schedule.noPendingItemsBtn': 'No pending items',
  'schedule.hideChangeHistory': 'Hide Change History',
  'schedule.showChangeHistory': 'Show Change History',
  'schedule.noScheduleCreated': 'No schedule has been created yet',
  'schedule.createFromDevTemplate': 'Create a default Development schedule with 156 items based on the Buildertrend schedule template.',
  'schedule.createFromDevTemplateBtn': 'Create schedule from Development template',
  'schedule.createFromRenovationTemplateBtn': 'Create schedule from Renovation template',
  'schedule.noScheduleCreatedRenovationDesc': 'Apply the default Renovation schedule preset with stages for bathroom, kitchen, and home renovation projects.',
  'schedule.renovationEmptyState': 'No schedule items yet. Add the first renovation task.',
  'schedule.addFirstTaskBtn': 'Add first task',
  'schedule.addTaskManuallyInstead': 'Or add a task manually',
  'schedule.applyPresetWarning': 'Applying this preset will add default schedule items. Existing items will not be deleted.',
  'schedule.settingUpSchedule': 'Setting up project schedule...',
  'schedule.scheduleItemsNeedDatesDesc': '{count} schedule items have been created, but no timeline dates are set yet.',
  'schedule.generateInitialTimelineBtn': 'Generate initial timeline',
  'schedule.noItemsMatchCurrentFilter': 'No schedule items match the current filter.',
  'schedule.clearFiltersBtn': 'Clear filters',
  'schedule.setupInProgressTitle': 'Schedule imported. Setup in progress.',
  'schedule.setupInProgressDesc': 'Complete checklist mapping and progress tracking before relying on critical path alerts. Critical path analysis is disabled by default.',
  'schedule.projectProgressWillReach100': 'Project Progress will reach 100% after all pending schedule items are marked complete.',
  'schedule.markAllConfirmTitle': 'Mark All Pending Complete?',
  'schedule.markAllConfirmDesc': 'This will mark {count} schedule items as complete with Final 100% progress. Items that are already complete will not be affected.',
  'schedule.markAllWarningText': 'This action cannot be undone easily. All pending schedule items will be set to complete regardless of checklist status.',
  'schedule.markingLabel': 'Marking...',
  'schedule.markCountCompleteBtn': 'Mark {count} Complete',
  'schedule.cancelBtn': 'Cancel',
  'schedule.recalcCriticalPathTitle': 'Recalculate Critical Path?',
  'schedule.recalcCriticalPathDesc': 'This will compute the critical path from the current schedule items and links, then save is_critical flags to Supabase.',
  'schedule.recalcCriticalPathWarning': 'Critical path alerts will be enabled after recalculation. Items not on the critical path will have their critical flag cleared.',
  'schedule.calculatingLabel': 'Calculating...',
  'schedule.recalcAndSaveBtn': 'Recalculate & Save',

  // Instructions inline labels
  'instructions.changeOrderLabel': 'Change Order',
  'instructions.clientApprovalLabel': 'Client Approval',
  'instructions.linkedScheduleLabel': 'Linked Schedule',
  'instructions.linkedChecklistLabel': 'Linked Checklist',
  'instructions.linkedPhotoLabel': 'Linked Photo',
  'instructions.changeOrderDetailsLabel': 'Change Order Details',
  'instructions.reasonLabel': 'Reason',
  'instructions.currentLabel': 'Current',
  'instructions.newLabel': 'New',
  'instructions.costLabel': 'Cost',
  'instructions.scheduleLabel': 'Schedule',
  'instructions.managementNoteLabel': 'Management Note',
  'instructions.readMoreBtn': 'Read more',
  'instructions.showLessBtn': 'Show less',
  'instructions.markCompletedBtn': 'Mark Completed',
  'instructions.markClosedBtn': 'Mark Closed',
  'instructions.acknowledgedLabel': 'Acknowledged',
  'instructions.completedLabel': 'Completed',
  'instructions.readLabel': 'Read',
  'instructions.noInstructionsYet': 'No instructions yet',
  'instructions.createInstructionDesc': 'Create an instruction to send to subcontractors',
  'instructions.createChangeOrderBtn': 'Create Change Order',
  'instructions.createFirstInstructionBtn': 'Create First Instruction',
  'instructions.changeOrderBtn': 'Change Order',
  'instructions.newInstructionBtn': 'New Instruction',

  // Payments inline labels
  'payments.title': 'Payments',
  'payments.addPayment': 'Add Payment',
  'payments.editPayment': 'Edit Payment',
  'payments.addFirstPayment': 'Add First Payment',
  'payments.addPaymentItem': 'Add Payment Item',
  'payments.noPaymentSchedule': 'No payment schedule yet',
  'payments.addPaymentMilestones': 'Add payment milestones for this project',
  'payments.total': 'Total',
  'payments.paid': 'Paid',
  'payments.remaining': 'Remaining',
  'payments.clientNotified': 'client has been notified in their portal',
  'payments.clientNotifiedPayment': 'Client notified payment',
  'payments.confirmPaymentReceived': 'Confirm Payment Received',
  'payments.saveChanges': 'Save Changes',
  'payments.cancel': 'Cancel',
  'payments.delete': 'Delete',
  'payments.titleLabel': 'Title',
  'payments.descriptionLabel': 'Description',
  'payments.amountLabel': 'Amount (NZD)',
  'payments.dueDateLabel': 'Due Date',
  'payments.statusLabel': 'Status',
  'payments.paymentReferenceLabel': 'Payment Reference',
  'payments.paymentDateLabel': 'Payment date',
  'payments.amountPaidLabel': 'Amount paid',
  'payments.referenceLabel': 'Reference',
  'payments.noteLabel': 'Note',
  'payments.optional': '(optional)',
  'payments.required': '*',
  'payments.upcoming': 'Upcoming',
  'payments.dueNowStatus': 'Due Now',
  'payments.overdueStatus': 'Overdue',
  'payments.paidStatus': 'Paid',
  'payments.pendingConfirmationStatus': 'Pending Confirmation',
  'payments.daysOverdue': '{n}d overdue',
  'payments.dueToday': 'Due today',
  'payments.dueInDays': 'Due in {n}d',
  'payments.reviewAndConfirm': 'Client has notified payment completion. Review and confirm below.',

  // Notification detail sheet
  'notifDetail.images': 'Images',
  'notifDetail.image': 'Image',
  'notifDetail.files': 'Files',
  'notifDetail.file': 'File',

  // Tasks type/status/role labels (used in reactive configs)
  'tasks.typeGeneral': 'General',
  'tasks.typeDecision': 'Decision',
  'tasks.typeSelection': 'Selection',
  'tasks.typePayment': 'Payment',
  'tasks.typeApproval': 'Approval',
  'tasks.typeInformation': 'Information',
  'tasks.statusPending': 'Pending',
  'tasks.statusAwaitingResponse': 'Awaiting Response',
  'tasks.statusCompleted': 'Completed',
  'tasks.statusOverdue': 'Overdue',
  'tasks.statusCancelled': 'Cancelled',
  'tasks.payStatusNA': 'N/A',
  'tasks.payStatusUnpaid': 'Unpaid',
  'tasks.payStatusPartial': 'Partial',
  'tasks.payStatusPaid': 'Paid',
  'tasks.payStatusOverdue': 'Overdue',
  'tasks.roleManagement': 'Management',
  'tasks.roleSubcontractor': 'Subcontractor',
  'tasks.roleClient': 'Client',
  'tasks.roleAllParties': 'All Parties',
  'tasks.filterAll': 'All',
  'tasks.filterOpen': 'Open',
  'tasks.filterDecision': 'Decision',
  'tasks.filterPayment': 'Payment',
  'tasks.filterOverdue': 'Overdue',
  'tasks.filterCompleted': 'Completed',

  // Stages status labels
  'stages.statusNotStarted': 'Not Started',
  'stages.statusInProgress': 'In Progress',
  'stages.statusCompleted': 'Completed',
  'stages.statusDelayed': 'Delayed',

  // Payments status labels
  'payments.statusUpcoming': 'Upcoming',
  'payments.statusDueNow': 'Due Now',
  'payments.statusOverdue': 'Overdue',
  'payments.statusPaid': 'Paid',
  'payments.statusPendingConfirmation': 'Pending Confirmation',

  // NewProject wizard additional keys
  'newProject.info': 'Info',
  'newProject.type': 'Type',
  'newProject.scheduleSetupStep': 'Schedule Setup',
  'newProject.cover': 'Cover',
  'newProject.team': 'Team',
  'newProject.stagesStep': 'Stages',
  'newProject.scheduleStep': 'Schedule',
  'newProject.scheduleStepDesc': 'Set up the project schedule and optional overall timeline dates.',
  'newProject.lightRenovationTasksHeading': 'Initial schedule tasks (11)',
  'newProject.paymentsStep': 'Payments',
  'newProject.review': 'Review',
  'newProject.development': 'Development',
  'newProject.renovation': 'Renovation',
  'newProject.other': 'Other',
  'newProject.scheduleSource': 'Schedule Source',
  'newProject.useDefaultTemplate': 'Use default template',
  'newProject.copyFromExisting': 'Copy from existing project',
  'newProject.createScheduleLater': 'Create schedule later',
  'newProject.createDefaultSchedule': 'Create default schedule',
  'newProject.includeDependencyLinks': 'Include dependency links',
  'newProject.generateInitialTimeline': 'Generate initial timeline now',
  'newProject.scheduleStartDate': 'Schedule Start Date',
  'newProject.workingDays': 'Working days',
  'newProject.workingDaysDesc': 'Default: Mon–Sat, excluding Sundays and NZ public holidays.',
  'newProject.noTemplateSchedule': 'No template schedule will be created. You can add one later from the Schedule tab.',
  'newProject.selectProjectToCopy': 'Select project to copy schedule from',
  'newProject.loadingProjects': 'Loading projects...',
  'newProject.chooseExistingProject': 'Choose an existing project...',
  'newProject.scheduleItems': 'schedule items',
  'newProject.pleaseSelectProject': 'Please select a project to copy schedule from.',
  'newProject.noExistingProjects': 'No existing projects with schedules found.',
  'newProject.sourceProjectSummary': 'Source Project Summary',
  'newProject.loadingSummary': 'Loading summary...',
  'newProject.scheduleItemsLabel': 'Schedule items',
  'newProject.stagesLabel2': 'Stages',
  'newProject.dependencyLinks': 'Dependency links',
  'newProject.available': 'available',
  'newProject.notAvailable': 'not available',
  'newProject.originalDateRange': 'Original date range',
  'newProject.checklistMappings': 'Checklist mappings',
  'newProject.couldNotLoadSummary': 'Could not load project summary.',
  'newProject.copyOptions': 'Copy options',
  'newProject.copyScheduleItems': 'Copy schedule items',
  'newProject.copyStages': 'Copy stages',
  'newProject.copyDependencyLinks': 'Copy dependency links',
  'newProject.copyChecklistMappings': 'Copy checklist mappings',
  'newProject.copyChecklistMappingsDesc': 'Only if schedule items and checklist are compatible',
  'newProject.dateHandling': 'Date handling',
  'newProject.generateTimelineFromStart': 'Generate timeline from new project start date',
  'newProject.preservesDurations': 'Preserves durations, recalculates start/end dates',
  'newProject.newProjectStartDate': 'New project start date',
  'newProject.useProjectStartDate': 'Use project start date',
  'newProject.itemsCopiedWithDurationsOnly': 'Items will be copied with durations only. No start/end dates will be set until you generate the timeline later.',
  'newProject.completionStatusNotCopied': 'Completion status and actual dates from the source project will not be copied. The new project schedule will start fresh.',
  'newProject.noScheduleWillBeCreated': 'No schedule will be created now.',
  'newProject.createOrImportLater': 'You can create or import a schedule later from the Schedule tab after project creation.',
  'newProject.afterCreationScheduleTab': 'After creation, the Schedule tab will show an empty state with options to build a custom schedule, apply a template, or copy from another project at any time.',
  'newProject.uploadOrLeaveBlank': 'Upload a photo or leave blank for the default',
  'newProject.coverPreview': 'Cover preview',
  'newProject.customPhoto': 'Custom photo',
  'newProject.defaultCover': 'Default cover',
  'newProject.clickOrDragDrop': 'Click or drag & drop to upload',
  'newProject.jpgPngWebp': 'JPG, PNG, WebP — max 5MB',
  'newProject.uploading': 'Uploading...',
  'newProject.orPasteUrl': 'or paste a URL',
  'newProject.coverPhotoUrl': 'Cover Photo URL',
  'newProject.coverUrlPlaceholder': 'https://... (leave blank for default)',
  'newProject.resetToDefault': 'Reset to default cover',
  'newProject.defaultCoversByType': 'Default covers by project type:',
  'newProject.developmentCoverDesc': 'Development — timber framing / new build construction image',
  'newProject.renovationCoverDesc': 'Renovation — interior remodel / kitchen renovation image',
  'newProject.changeCoverAnytime': 'You can change the cover photo anytime from Edit Project → Type & Cover.',
  'newProject.optionalAddTeam': 'Optional — add subcontractor and client. You can also do this later.',
  'newProject.existingAccountsAdded': 'Existing accounts added immediately',
  'newProject.ifEmailHasAccount': 'If the email already has an account, they will be added to this project. New accounts require the edge function to be deployed — if it fails, the project is still created and you can add team members later.',
  'newProject.optionalSetTimeline': 'Optional — set the overall project timeline. Editable later.',
  'newProject.stageDatesFromEdit': 'Stage-by-stage dates can be set from Edit Project → Stages after creation.',
  'newProject.monthsDuration': '{n} months duration',
  'newProject.weeksDuration': '{n} weeks duration',
  'newProject.weekDuration': '{n} week duration',
  'newProject.daysDuration': '{n} days duration',
  'newProject.dayDuration': '{n} day duration',
  'newProject.setUpPaymentNow': 'Set up payment schedule now',
  'newProject.addLaterFromEdit': 'You can also add this later from Edit Project',
  'newProject.noPaymentsAdded': 'No payments added yet',
  'newProject.startFromTemplate': 'Start from a template or add items manually',
  'newProject.loadStandardTemplate': 'Load Standard Template',
  'newProject.addManually': 'Add Manually',
  'newProject.payment': 'Payment',
  'newProject.done': 'Done',
  'newProject.titleRequired': 'Title',
  'newProject.descriptionOptional': 'Description',
  'newProject.amountNZD': 'Amount (NZD)',
  'newProject.dueDate': 'Due Date',
  'newProject.reference': 'Reference',
  'newProject.untitledPayment': 'Untitled payment',
  'newProject.noAmountSet': 'No amount set',
  'newProject.addPaymentItem': 'Add Payment Item',
  'newProject.totalScheduled': 'Total scheduled',
  'newProject.setUpPaymentLater': 'You can set up the payment schedule later from Edit Project → Payments tab.',
  'newProject.confirmDetails': 'Confirm all details before creating the project',
  'newProject.projectCreatedSuccess': 'Project created successfully!',
  'newProject.noAddress': 'No address',
  'newProject.projectDetailsSection': 'Project Details',
  'newProject.projectNameLabel': 'Project Name',
  'newProject.siteAddressLabel': 'Site Address',
  'newProject.clientLabel': 'Client',
  'newProject.typeLabel': 'Type',
  'newProject.startDateLabel': 'Start Date',
  'newProject.estCompletionLabel': 'Est. Completion',
  'newProject.notSet': 'Not set',
  'newProject.scheduleSetupSection': 'Schedule Setup',
  'newProject.createDefaultFromTemplate': 'Create default schedule from template',
  'newProject.includeDependencyLinksLabel': 'Include dependency links',
  'newProject.generateTimelineFrom': 'Generate initial timeline from',
  'newProject.copyScheduleFromExisting': 'Copy schedule from existing project',
  'newProject.copyScheduleItemsLabel': 'Copy schedule items',
  'newProject.copyStagesLabel': 'Copy stages',
  'newProject.copyDependencyLinksLabel': 'Copy dependency links',
  'newProject.copyChecklistMappingsLabel': 'Copy checklist mappings',
  'newProject.recalculateDatesLabel': 'Recalculate dates from new start date',
  'newProject.copyAsUndated': 'Copy as undated schedule (durations only)',
  'newProject.noDefaultSchedule': 'No default schedule — can be added later from Schedule tab',
  'newProject.manualSchedulePreview': 'No default schedule. Tasks can be added manually from the Schedule tab.',
  'newProject.stagesAddedLater': 'Stages can be added later.',
  'newProject.stagesSection': 'Stages',
  'newProject.teamSection': 'Team',
  'newProject.paymentScheduleSection': 'Payment Schedule',
  'newProject.paymentItems': 'items',
  'newProject.total': 'Total',
  'newProject.noPaymentScheduleNote': 'No payment schedule — can be added later from Edit Project',
  'newProject.readyToCreateDesc': 'A unique project code will be generated automatically. The project will be created immediately using direct database insert.',
  'newProject.renovationTemplateNotConfigured': 'Renovation schedule template is not configured yet.',
  'newProject.canStillCreateProject': 'You can still create the project and set up the schedule later from the Schedule tab.',
  'newProject.customPhotoSet': 'Custom photo set',
  'newProject.autoUsedUnlessCustom': 'This image will be used automatically unless you upload a custom cover photo in the next step.',
  'newProject.defaultCoverPhoto': 'Default Cover Photo',
  'newProject.defaultCoverLabel': '{type} default cover',

  // New project creation result status
  'newProject.scheduleCreatedOk': 'Schedule created successfully',
  'newProject.scheduleNotCreated': 'Schedule was not created — you can add it from the Schedule tab',
  'newProject.checklistCreatedOk': 'Checklist created successfully',
  'newProject.checklistNotCreated': 'Checklist creation failed',
  'newProject.checklistNotCreatedDesc': 'You can create the default checklist from the Checklist tab after opening the project.',
  'newProject.settingUpSchedule': 'Setting up project schedule...',
  'newProject.settingUpChecklist': 'Setting up project checklist...',
  'newProject.copyingSchedule': 'Copying schedule from existing project...',
  'newProject.retryScheduleSetup': 'Retry schedule setup',
  'newProject.retryChecklistSetup': 'Retry checklist setup',
  'newProject.retrying': 'Retrying...',
  'newProject.presetItemCount': '{count} schedule items',
  'newProject.presetLinkCount': '{count} dependency links',
  'newProject.presetBuiltIn': 'Built-in preset',
  'newProject.loadingPresetInfo': 'Loading preset information...',
  'newProject.noPresetConfigured': 'No preset is configured for this project type. You can still create the project and add a schedule later.',
  'newProject.renovationManualScheduleTitle': 'Light renovation schedule',
  'newProject.renovationManualScheduleDesc': 'A light renovation schedule will be created. You can edit, delete, or add tasks after the project is created.',
  'newProject.lightRenovationSchedulePreview': 'Light renovation schedule with 11 common phases will be created. You can edit, delete, or add tasks after creation.',
  'newProject.blankCustomTitle': 'Blank / custom project',
  'newProject.blankCustomScheduleDesc': 'No default schedule or checklist will be created. Add them later only if needed.',

  // Checklist setup in new project wizard
  'newProject.createDefaultChecklist': 'Create default checklist',
  'newProject.createDefaultChecklistDesc': 'Copy the default checklist template for this project type.',
  'newProject.createDefaultChecklistLaterDesc': 'Copy the default checklist template. Schedule can be added later.',
  'newProject.createDefaultChecklistLabel': 'Create default checklist from template',
  'newProject.linkChecklistToSchedule': 'Link checklist to schedule where possible',
  'newProject.linkChecklistToScheduleDesc': 'Map checklist items to schedule items based on stage/phase.',
  'newProject.noTemplateScheduleChecklist': 'No template schedule or checklist will be created. You can add them later from the Schedule and Checklist tabs.',
  'newProject.copyChecklistItems': 'Copy checklist items',
  'newProject.copyChecklistItemsDesc': 'Copy all checklist items from the source project, reset to incomplete.',
  'newProject.copyChecklistItemsLabel': 'Copy checklist items',
  'newProject.resetChecklistCompletion': 'Reset all completion states',
  'newProject.resetChecklistCompletionDesc': 'All copied checklist items will start as incomplete.',
  'newProject.checklistsLabel': 'Checklists',
  'newProject.checklistItemsLabel': 'Checklist items',
  'newProject.checklistItems': 'checklist items',

  // Checklist mobile labels
  'checklist.mgmtPending': 'mgmt pending',
  'checklist.subPending': 'sub pending',
  'checklist.pending': 'pending',
  'checklist.completed': 'Completed',

  // ChecklistItemCard keys
  'checklistCard.complete': 'Complete',
  'checklistCard.required': 'Required',
  'checklistCard.mgmtPending': 'Mgmt pending',
  'checklistCard.subPending': 'Sub pending',
  'checklistCard.mgmt': 'Mgmt',
  'checklistCard.sub': 'Sub',
  'checklistCard.markAsIncomplete': 'Mark as incomplete',
  'checklistCard.markAsComplete': 'Mark as complete',
  'checklistCard.completed': 'Completed',
  'checklistCard.awaitingMgmt': 'Awaiting management confirmation',
  'checklistCard.awaitingSubcontractor': 'Awaiting subcontractor confirmation',
  'checklistCard.checkedRecently': 'recently',
  'checklistCard.notes': 'Notes',
  'checklistCard.management': 'Management',
  'checklistCard.subcontractor': 'Subcontractor',

  // Instructions priority labels
  'priority.high': 'High',
  'priority.medium': 'Medium',
  'priority.low': 'Low',
  'priority.allPriorities': 'All Priorities',

  // Date/time formatting
  'date.today': 'Today',
  'date.nonWorkday': 'Non-workday',
  'date.publicHoliday': 'Public Holiday',
  'date.offDay': 'Off',
  'date.month': 'Month',
  'date.week': 'Week',
  'date.day': 'Day',

  // Notifications additional
  'notifications.markAsRead': 'Mark as read',
  'notifications.newNotification': 'New notification',
  'notifications.emailSent': 'Email notification sent',
  'notifications.emailFailed': 'Email notification failed',

  // Files additional
  'files.fileName': 'File name',
  'files.fileType': 'File type',
  'files.uploadedBy': 'Uploaded by',
  'files.uploadedDate': 'Uploaded date',
  'files.visibleToClient': 'Visible to client',
  'files.managementOnly': 'Management only',
  'files.uploadFile': 'Upload file',

  // Daily Log additional
  'dailyLog.uploadedBy': 'Uploaded by',
  'dailyLog.uploadedDate': 'Uploaded date',
  'dailyLog.reviewPhotos': 'Review photos',
  'dailyLog.pendingManagementReview': 'Pending management review',
  'dailyLog.approveForClientBtn': 'Approve for client',
  'dailyLog.keepInternalBtn': 'Keep internal',

  // Payments additional
  'payments.paymentSchedule': 'Payment schedule',
  'payments.amount': 'Amount',
  'payments.paymentConfirmed': 'Payment confirmed',
  'payments.awaitingConfirmation': 'Awaiting confirmation',
  'payments.unpaid': 'Unpaid',

  // Tasks additional
  'tasks.internalTask': 'Internal task',
  'tasks.clientTask': 'Client task',
  'tasks.priority': 'Priority',
  'tasks.paymentTask': 'Payment task',
  'tasks.decisionTask': 'Decision task',
  'tasks.generalTask': 'General task',

  // Checklist filter labels
  'checklist.filterAll': 'All',
  'checklist.filterUnchecked': 'Unchecked',
  'checklist.filterChecked': 'Checked',
  'checklist.filterWaitMgmt': 'Wait Mgmt',
  'checklist.filterWaitSub': 'Wait Sub',
  'checklist.filterFullyApproved': 'Fully Approved',
  'checklist.filterUnmapped': 'Unmapped',
  'checklist.checksCount': 'checks',
  'checklist.stageProgress': '{stage} Progress',
  'checklist.mgmtLabel': 'Mgmt',
  'checklist.subLabel': 'Sub',
  'checklist.finalLabel': 'Final',
  'checklist.paymentPercent': '{n}% payment',

  // Schedule hardcoded strings
  'schedule.refreshingScheduleData': 'Refreshing schedule data...',
  'schedule.scheduleProgressSuggestsMoving': 'Schedule progress suggests moving this project to {stage}.',
  'schedule.dismiss': 'Dismiss',
  'schedule.updateProjectStage': 'Update project stage',
  'schedule.checklistFinalColon': 'Checklist Final:',
  'schedule.scheduleFinalColon': 'Schedule Final:',
  'schedule.projectProgressColon': 'Project Progress:',
  'schedule.calculatedFrom50Pct': 'Calculated from 50% Checklist + 50% Schedule',
  'schedule.projectProgressWillReach': 'Project Progress will reach 100% after all pending schedule items are marked complete.',
  'schedule.scheduleCompleteAll': 'Schedule Final: {pct}% — All {total} items complete',
  'schedule.pendingItemsCount': '{count} schedule item{plural} pending completion',
  'schedule.noMappingIncomplete': '{count} item{plural} {have} no checklist mapping and {is} still incomplete. Complete them manually or map them to checklist items.',
  'schedule.incompleteLinkedChecklist': '{count} item{plural} {have} incomplete linked checklist.',
  'schedule.completedNotLinked': '{count} completed item{plural} {are} not linked to checklist items. They still count as complete.',
  'schedule.markAllPendingComplete': 'Mark all pending schedule items complete',
  'schedule.noPendingItems': 'No pending items',
  'schedule.reviewPendingItemsBtn': 'Review pending items',
  'schedule.noChecklistMappingBtn': 'No Checklist Mapping',
  'schedule.incompleteChecklistBtn': 'Incomplete Checklist',
  'schedule.hideChangeHistory': 'Hide Change History',
  'schedule.showChangeHistory': 'Show Change History',
  'schedule.noScheduleCreatedDesc': 'Create a default Development schedule with 156 items based on the Buildertrend schedule template.',
  'schedule.createFromDevTemplateBtn': 'Create schedule from Development template',
  'schedule.scheduleItemsNeedDatesDesc': '{count} schedule items have been created, but no timeline dates are set yet.',
  'schedule.generateInitialTimelineBtn': 'Generate initial timeline',
  'schedule.noItemsMatchCurrentFilter': 'No schedule items match the current filter.',
  'schedule.clearFiltersBtn': 'Clear filters',
  'schedule.setupInProgressTitle': 'Schedule imported. Setup in progress.',
  'schedule.setupInProgressDesc': 'Complete checklist mapping and progress tracking before relying on critical path alerts. Critical path analysis is disabled by default — use Recalculate Critical Path in the More menu when ready.',
  'schedule.markAllConfirmTitle': 'Mark All Pending Complete?',
  'schedule.markAllConfirmDesc': 'This will mark {count} schedule items as complete with Final 100% progress. Items that are already complete will not be affected.',
  'schedule.markAllWarningText': 'This action cannot be undone easily. All pending schedule items will be set to complete regardless of checklist status.',
  'schedule.markingLabel': 'Marking...',
  'schedule.markCountCompleteBtn': 'Mark {count} Complete',
  'schedule.cancelBtn': 'Cancel',
  'schedule.recalcCriticalPathTitle': 'Recalculate Critical Path?',
  'schedule.recalcCriticalPathDesc': 'This will compute the critical path from the current schedule items and links, then save is_critical flags to Supabase.',
  'schedule.recalcCriticalPathWarning': 'Critical path alerts will be enabled after recalculation. Items not on the critical path will have their critical flag cleared.',
  'schedule.calculatingLabel': 'Calculating...',
  'schedule.recalcAndSaveBtn': 'Recalculate & Save',
  'schedule.retryBtn': 'Retry',

  // Instructions tab hardcoded strings
  'instructions.changeOrderBadge': 'Change Order',
  'instructions.clientApprovalBadge': 'Client Approval',
  'instructions.linkedScheduleBadge': 'Linked Schedule',
  'instructions.linkedChecklistBadge': 'Linked Checklist',
  'instructions.linkedPhotoBadge': 'Linked Photo',
  'instructions.changeOrderDetailTitle': 'Change Order Details',
  'instructions.reasonColon': 'Reason:',
  'instructions.currentColon': 'Current:',
  'instructions.newColon': 'New:',
  'instructions.costColon': 'Cost:',
  'instructions.scheduleColon': 'Schedule:',
  'instructions.managementNoteTitle': 'Management Note',
  'instructions.readMoreBtn': 'Read more',
  'instructions.showLessBtn': 'Show less',
  'instructions.markCompletedBtn': 'Mark Completed',
  'instructions.markClosedBtn': 'Mark Closed',
  'instructions.acknowledgedBadge': 'Acknowledged',
  'instructions.completedBadge': 'Completed',
  'instructions.readBadge': 'Read',
  'instructions.highPriorityBadge': 'High Priority',
  'instructions.responseRequiredBadge': 'Response Required',
  'instructions.changeOrderBtn2': 'Change Order',
  'instructions.newInstructionBtn2': 'New Instruction',
  'instructions.createChangeOrderBtn2': 'Create Change Order',
  'instructions.createFirstInstructionBtn2': 'Create First Instruction',
  'instructions.noInstructionsYetMsg': 'No instructions yet',
  'instructions.createInstructionMsg': 'Create an instruction to send to subcontractors',
  'instructions.noStatusInstructions': 'No {status} instructions',
  'instructions.toLabel': 'To:',
  'instructions.dueLabel': 'Due',

  // Notifications filter types
  'notifications.filterAll': 'All',
  'notifications.filterProgress': 'Progress',
  'notifications.filterIssue': 'Issue',
  'notifications.filterApproval': 'Approval',
  'notifications.filterQuestion': 'Question',
  'notifications.filterTask': 'Task',
  'notifications.filterPayment': 'Payment',
  'notifications.filterUpdate': 'Update',
  'notifications.filterPhoto': 'Photo',
  'notifications.filterFile': 'File',

  // Daily Log toast messages
  'dailyLog.toastTitleRequired': 'Please enter a title',
  'dailyLog.selectProject': 'Select a project...',
  'dailyLog.toastCreatedSuccess': 'Daily Log created successfully',
  'dailyLog.toastCreateFailed': 'Failed to create Daily Log',

  // Daily Log created entries list
  'dailyLog.createdDailyLogs': 'Created Daily Logs',
  'dailyLog.untitledDailyLog': 'Untitled Daily Log',
  'dailyLog.viewDailyLog': 'View Daily Log',
  'dailyLog.view': 'View',
  'dailyLog.previewAsClient': 'Preview as client',
  'dailyLog.loadingDailyLogs': 'Loading Daily Logs...',

  // NewProject type descriptions
  'newProject.developmentDesc': 'New construction from ground up. Includes land development, new builds, and multi-unit projects.',
  'newProject.renovationDesc': 'Existing structure upgrade or remodel. Includes full renovations, extensions, and fit-outs.',
  'newProject.otherDesc': 'Custom or mixed-use project. Schedule can be configured later from the Schedule tab.',

  // Stages progress percent label
  'stages.progressPct': '{pct}% progress',
  'stages.paymentPercent': '{n}% payment',
  'stages.currentStageLabel': 'Current Stage',
  'stages.notSet': 'Not Set',
  'stages.setStageBtn': 'Set Stage',
  'stages.noItemsYet': 'No items yet — 0%',
  'stages.moveToPrev': 'Move Back',
  'stages.moveToNext': 'Move Forward',
  'stages.movedToStageToast': 'Project moved to {stage}',
  'stages.unassignedStage': 'Unassigned',
  'stages.unassignedDesc': 'Tasks without a stage — assign from the Schedule tab. These do not block stage progression.',
  'stages.moveAllToConstructionBtn': 'Move all to Construction',
  'stages.movedUnassignedToConstructionToast': 'Moved {count} task(s) to Construction',
  'stages.moveUnassignedFailed': 'Could not move tasks to Construction. Please try again.',
  'stages.moveStageAnywayTitle': 'Move project stage?',
  'stages.moveStageAnywayConfirm': '{stages} has incomplete items. Move to {stage} anyway?',
  'stages.moveStageAnywayBtn': 'Move anyway',
  'stages.stageUpdateFailed': 'Could not update project stage. Please try again.',
  'stages.checksCount': '{n} checks',
  'stages.checklistItemsCount': '{n} checklist items',
  'stages.completedCount': '{n} completed',
  'stages.mgmtCount': 'Mgmt {checked}/{total}',
  'stages.subCount': 'Sub {checked}/{total}',

  // FileUploader shared component
  'upload.title': 'Upload',
  'upload.takePhoto': 'Take Photo',
  'upload.choosePhotos': 'Choose Photos',
  'upload.uploadFile': 'Upload File',
  'upload.dropFilesHere': 'Drop files here, or click to select',
  'upload.selectPhotos': 'Select Photos',
  'upload.selectFiles': 'Select Files',
  'upload.addCaption': 'Add a caption...',
  'upload.uploading': 'Uploading…',
  'upload.retryFailed': 'Retry Failed',
  'upload.done': 'Done',
  'upload.upload': 'Upload',
  'upload.file': 'file',
  'upload.files': 'files',
  'upload.selected': 'selected',
  'upload.uploaded': 'uploaded',
  'upload.closingMoment': 'Closing in a moment…',
  'upload.fileTooLarge': 'is too large (max {max})',
  'upload.totalExceeds': 'Total upload size exceeds {max}',
  'upload.maxFiles': 'Maximum {max} files allowed',
  'upload.notAnImage': 'is not an image. Only photos are allowed.',
  'upload.pdfNotAllowed': 'PDF uploads are not allowed.',
  'upload.addCaptionFor': 'Add a caption for {count} file',
  'upload.addCaptionForPlural': 'Add a caption for {count} files',
  'upload.jpgPngWebpHeic': 'JPG, PNG, WebP, HEIC',
  'upload.jpgPngPdfDocs': 'JPG, PNG, PDF, documents',
  'upload.jpgPngDocs': 'JPG, PNG, documents',
  'upload.maxEach': 'Max {max} each',

  // PhotoLightbox
  'lightbox.pinchToZoom': 'Pinch to zoom · Swipe to navigate',
  'lightbox.imageCouldNotLoad': 'Image could not be loaded',

  // ProjectDetail hardcoded strings
  'projectDetail.noAddressSet': 'No address set',
  'projectDetail.description': 'Description',
  'projectDetail.reviewPendingSchedule': 'Review Pending Schedule',
  'projectDetail.pendingScheduleItems': '{count} schedule items pending',
  'projectDetail.checklistItemsPending': '{count} checklist items pending',
  'projectDetail.checklistFinalPct': 'Checklist Final: {pct}%',
  'projectDetail.scheduleFinalPct': 'Schedule Final: {pct}%',
  'projectDetail.projectProgressPct': '{pct}% Project Progress',
  'projectDetail.scheduleFormula': 'Schedule Final {sched}% × 50% + Checklist Final {cl}% × 50% = {total}% Project Progress',
  'projectDetail.checklistComplete100': 'Checklist is 100% complete. Project Progress is stuck at {pct}% because Schedule Final is {schedPct}%. Complete or manually mark schedule items to reach 100%.',
  'projectDetail.progressFormula': 'Project Progress = Schedule Final 50% + Checklist Final 50%. To reach 100%, complete both schedule items and checklist items.',
  'projectDetail.viewPendingItems': 'View Pending Items',
  'projectDetail.mgmtChecksComplete': 'Management checks complete. Waiting for subcontractor checks.',
  'projectDetail.subPendingDesc': '{remaining} of {total} subcontractor-required checklist items are still pending subcontractor confirmation. Schedule, Stage, and Project progress will not reach 100% until all subcontractor checks are complete.',
  'projectDetail.scheduleProgressSuggestsMoving': 'Schedule progress suggests moving this project to',
  'projectDetail.updateProjectStage': 'Update project stage',
  'projectDetail.dismiss': 'Dismiss',

  // Checklist recovery flow
  'checklist.createDefaultChecklistForProject': 'Create default checklist for this project',
  'checklist.creatingDefaultChecklist': 'Creating checklist...',
  'checklist.defaultChecklistCreated': 'Default checklist created with {count} items.',
  'checklist.defaultChecklistExists': 'Checklist already exists for this project.',
  'checklist.failedToCreateDefault': 'Failed to create default checklist. Please try again.',
  'checklist.checklistCreatedSuccess': 'Checklist created successfully!',
  'checklist.checklistCreationFailed': 'Checklist creation failed',
  'checklist.checklistRecoveryNote': 'This will create all active checklist templates for this project type.',

  // Checklist by-section hardcoded strings
  'checklist.finalCompleteLabel': 'Final: Complete',
  'checklist.waitingForSubLabel': 'Waiting for Subcontractor',
  'checklist.waitingForMgmtLabel': 'Waiting for Management',
  'checklist.allItemsCheckedGreat': 'All checklist items are checked. Great work!',
  'checklist.viewCheckedItemsBtn': 'View checked items',

  // Notifications type badge (raw DB values)
  'notifType.progress': 'Progress',
  'notifType.issue': 'Issue',
  'notifType.inspection': 'Inspection',
  'notifType.approval': 'Approval',
  'notifType.question': 'Question',
  'notifType.task': 'Task',
  'notifType.system': 'System',
  'notifType.payment': 'Payment',
  'notifType.update': 'Update',
  'notifType.photo': 'Photo',
  'notifType.file': 'File',
  'notifType.schedule': 'Schedule',
  'notifType.instruction': 'Instruction',
  'notifType.checklist': 'Checklist',

  // Instructions page All filter
  'instructions.filterAll': 'All',

  // Daily Log note prefix
  'dailyLog.notePrefix': 'Note:',
  'dailyLog.failedToSaveNote': 'Failed to save note: ',
  'dailyLog.failedToDelete': 'Failed to delete: ',
  'dailyLog.actionRequired': 'Action required: ',

  // StagesTab progress label
  'stages.progressLabel': '{pct}% progress',
  'stages.paymentLabel': '{n}% payment',
  'stages.nilPaymentLabel': 'NIL',

  // ScheduleItemModal
  'scheduleModal.editItem': 'Edit Schedule Item',
  'scheduleModal.addItem': 'Add Schedule Item',
  'scheduleModal.basicInfo': 'Basic Info',
  'scheduleModal.datesProgress': 'Dates & Progress',
  'scheduleModal.linkedScheduleItems': 'Linked Schedule Items',
  'scheduleModal.linkedChecklistItems': 'Linked Checklist Items',
  'scheduleModal.checklistCompletionSummary': 'Checklist Completion Summary',
  'scheduleModal.ganttBarColor': 'Gantt Bar Color',
  'scheduleModal.notesTask': 'Notes & Task',
  'scheduleModal.titleLabel': 'Title *',
  'scheduleModal.phaseLabel': 'Phase',
  'scheduleModal.stageLabel': 'Stage',
  'scheduleModal.selectStage': '-- Select Stage --',
  'scheduleModal.constructionSubStage': 'Construction Sub-Stage',
  'scheduleModal.selectSubStage': '-- Select Sub-Stage --',
  'scheduleModal.durationLabel': 'Duration (working days)',
  'scheduleModal.assignedRole': 'Assigned Role',
  'scheduleModal.assignedTo': 'Assigned To',
  'scheduleModal.startDate': 'Start Date',
  'scheduleModal.endDate': 'End Date',
  'scheduleModal.progressLabel': 'Progress (%)',
  'scheduleModal.baselineStart': 'Baseline Start',
  'scheduleModal.baselineEnd': 'Baseline End',
  'scheduleModal.actualStart': 'Actual Start',
  'scheduleModal.actualEnd': 'Actual End',
  'scheduleModal.delayStatus': 'Delay Status',
  'scheduleModal.riskLevel': 'Risk Level',
  'scheduleModal.auto': 'Auto',
  'scheduleModal.complete': 'Complete',
  'scheduleModal.locked': 'Locked',
  'scheduleModal.noChecklist': 'No checklist',
  'scheduleModal.includedInProject': 'Included in project',
  'scheduleModal.criticalPath': 'Critical path',
  'scheduleModal.notSet': 'Not set',
  'scheduleModal.checklistProgress': 'Checklist Progress',
  'scheduleModal.completed': 'Completed',
  'scheduleModal.progress': 'Progress',
  'scheduleModal.mgmtChecked': 'Mgmt Checked',
  'scheduleModal.subChecked': 'Sub Checked',
  'scheduleModal.missing': 'Missing',
  'scheduleModal.totalLinked': 'Total Linked',
  'scheduleModal.mgmtChecksPending': 'Management checks pending',
  'scheduleModal.subChecksPending': 'Subcontractor checks pending',
  'scheduleModal.openLinkedChecklist': 'Open Linked Checklist',
  'scheduleModal.notesLabel': 'Notes',
  'scheduleModal.delayReason': 'Delay Reason',
  'scheduleModal.reasonForChange': 'Reason for change',
  'scheduleModal.reasonOptional': '(recommended for significant changes)',
  'scheduleModal.publishToClient': 'Publish schedule update to client',
  'scheduleModal.publishDesc': 'If checked, a client-friendly schedule update will be posted to the project updates.',
  'scheduleModal.saving': 'Saving...',
  'scheduleModal.saveChanges': 'Save Changes',
  'scheduleModal.addItemBtn': 'Add Item',
  'scheduleModal.createTask': 'Create Task from this Schedule Item',
  'scheduleModal.sendInstruction': 'Send Instruction to Subcontractor',
  'scheduleModal.recalcDownstream': 'Recalculate Downstream?',
  'scheduleModal.recalcDesc': 'This item has linked successors. Changing its duration will shift their dates. Do you want to recalculate all downstream items?',
  'scheduleModal.saveOnly': 'Save Only',
  'scheduleModal.saveAndRecalc': 'Save & Recalc',
  'scheduleModal.moveToNextWorkingDay': 'Move to next working day',
  'scheduleModal.keepThisDate': 'Keep this date',
  'scheduleModal.notWorkingDay': 'This date ({day}) is not a working day based on the current schedule settings.',
  'scheduleModal.progressDerivedFromChecklist': 'Progress is derived from linked checklist completion.',
  'scheduleModal.readyToComplete': 'Ready to complete — all checklist items done',
  'scheduleModal.notReady': 'Not ready — {completed} / {total} checklist items completed',
  'scheduleModal.mgmtChecksPendingDesc': '{count} checklist item(s) require management approval',
  'scheduleModal.subChecksPendingDesc': '{count} checklist item(s) require subcontractor approval',
  'scheduleModal.actionRequired': 'Action required: ',
  'scheduleModal.deleteItem': 'Delete Schedule Item',
  'scheduleModal.deleteItemTitle': 'Delete Schedule Item?',
  'scheduleModal.deleteItemConfirm': 'Are you sure you want to delete this schedule item? This action removes the item from the schedule and all dependency links.',
  'scheduleModal.deleteItemWarning': 'This action is irreversible. All linked dependency relationships will also be removed.',
  'scheduleModal.deleteConfirmBtn': 'Delete Item',
  'scheduleModal.cancelBtn': 'Cancel',

  // Schedule mobile timeline/card labels
  'schedule.daySingular': 'day',
  'schedule.dayPlural': 'days',
  'schedule.linkSingular': 'link',
  'schedule.linkPlural': 'links',
  'schedule.noDate': 'No date',
  'schedule.uncategorized': 'Uncategorized',
  'schedule.ganttSwipeHint': 'Swipe horizontally to view the full Gantt chart.',

  // Stage names
  'stage.Planning': 'Planning',
  'stage.Design': 'Design',
  'stage.Consent': 'Consent',
  'stage.Construction': 'Construction',
  'stage.Handover': 'Handover',

  // Checklist empty state new keys
  'checklist.noChecklistItemsDesc': 'No checklist items have been created for this project yet.',
  'checklist.refreshPage': 'Refresh page',
  'checklist.forceReload': 'Force reload checklist',
  'checklist.forceReloadChecklist': 'Force reload checklist data',

  // ProjectDetail new keys
  'projectDetail.pending': 'Pending',
  'projectDetail.reviewSchedule': 'Review Schedule',
  'projectDetail.reviewChecklist': 'Review Checklist',
  'projectDetail.scheduleItemsPending': 'schedule items pending',
  'projectDetail.checklistItemsPendingShort': 'checklist items pending',
  'projectDetail.waitingSubcontractor': 'Waiting for subcontractor',
  'progress.currentStage': 'Current stage',

  // PostUpdateModal
  'postUpdate.title': 'Post Update',
  'postUpdate.postAs': 'Post as {role}',
  'postUpdate.posting': 'Posting...',
  'postUpdate.updateType': 'Update Type',
  'postUpdate.allParties': 'All Parties',
  'postUpdate.managementOnly': 'Management Only',
  'postUpdate.mgmtAndSub': 'Management & Subcontractor',
  'postUpdate.enterTitle': 'Please enter a title',
  'postUpdate.enterDetails': 'Please enter details',
  'postUpdate.titlePlaceholder': 'e.g. Kitchen joinery installed',
  'postUpdate.details': 'Details',
  'postUpdate.detailsPlaceholder': 'Describe site progress, issues, or notes...',
  'postUpdate.clientHighlight': 'Client Highlight',
  'postUpdate.clientHighlightDesc': 'Feature this update in the client portal',
  'postUpdate.currentStage': 'Current Stage',
  'postUpdate.justNow': 'Just now',

  // FilesTab feedback
  'files.deleteFileFailed': 'Failed to delete file',
  'files.fileDeleted': 'File deleted',
  'files.updateVisibilityFailed': 'Failed to update visibility',
  'files.fileNowVisible': 'File is now visible',
  'files.fileHidden': 'File hidden',
  'files.moveFileFailed': 'Failed to move file',
  'files.movedToFolder': 'Moved to {folder}',
  'files.removedFromFolder': 'Removed from folder',

  // ScheduleFilterDrawer
  'scheduleFilter.title': 'Filter Schedule',
  'scheduleFilter.searchTitle': 'Search Title',
  'scheduleFilter.searchPlaceholder': 'Search schedule items...',
  'scheduleFilter.status': 'Status',
  'scheduleFilter.stage': 'Stage',
  'scheduleFilter.allStages': 'All Stages',
  'scheduleFilter.assignedTo': 'Assigned To',
  'scheduleFilter.all': 'All',
  'scheduleFilter.dateRange': 'Date Range',
  'scheduleFilter.allDates': 'All Dates',
  'scheduleFilter.thisWeek': 'This Week',
  'scheduleFilter.thisMonth': 'This Month',
  'scheduleFilter.customRange': 'Custom Range',
  'scheduleFilter.to': 'to',
  'scheduleFilter.showExcluded': 'Show excluded items',
  'scheduleFilter.clearAll': 'Clear All',
  'scheduleFilter.applyFilter': 'Apply Filter',
  'scheduleFilter.statusAll': 'All',
  'scheduleFilter.statusUnfinished': 'Unfinished',
  'scheduleFilter.statusCompleted': 'Completed',
  'scheduleFilter.statusDelayed': 'Delayed',
  'scheduleFilter.statusAtRisk': 'At Risk',

  // ScheduleCompletionBlockModal
  'completionBlock.allApprovalsComplete': 'All approvals complete',
  'completionBlock.manualCompletion': 'Manual completion',
  'completionBlock.cannotCompleteYet': 'Cannot complete yet',
  'completionBlock.waitingForApprovals': 'Waiting for approvals',
  'completionBlock.noChecklist': 'This schedule item has no linked checklist.',
  'completionBlock.noChecklistMgmtOnly': 'This schedule item has no linked checklist. Only management can mark it complete manually.',
  'completionBlock.mgmtPlusSub': '{mgmt} management + {sub} subcontractor checks pending',
  'completionBlock.subPending': '{sub} subcontractor {check} pending',
  'completionBlock.mgmtPending': '{mgmt} management {check} pending',
  'completionBlock.requiredApprovalsIncomplete': 'Required approvals are not complete',
  'completionBlock.check': 'check',
  'completionBlock.checks': 'checks',
  'completionBlock.management': 'Management',
  'completionBlock.subcontractor': 'Subcontractor',
  'completionBlock.allDone': 'All done',
  'completionBlock.pending': 'pending',
  'completionBlock.approvalUnits': '{completed} / {total} approval units',
  'completionBlock.allApprovalsReady': 'All required checklist approvals are complete. This schedule item is ready to be marked complete.',
  'completionBlock.reasonForManual': 'Reason for manual completion',
  'completionBlock.reasonPlaceholder': 'e.g. This is a milestone marker with no associated checklist items...',
  'completionBlock.provideReason': 'Please provide a reason before manually completing this item.',
  'completionBlock.cancel': 'Cancel',
  'completionBlock.markComplete': 'Mark Complete',
  'completionBlock.overrideComplete': 'Override & Complete',
  'completionBlock.confirmOverride': 'Confirm Override',

  // ScheduleSettingsModal
  'scheduleSettings.title': 'Schedule Settings',
  'scheduleSettings.workingDays': 'Working Days',
  'scheduleSettings.holidays': 'Holidays',
  'scheduleSettings.countryCode': 'Country Code',
  'scheduleSettings.countryPlaceholder': 'e.g. NZ',
  'scheduleSettings.region': 'Region',
  'scheduleSettings.regionPlaceholder': 'e.g. Auckland',
  'scheduleSettings.save': 'Save Settings',
  'scheduleSettings.saving': 'Saving...',
  'scheduleSettings.cancel': 'Cancel',
  'scheduleSettings.monday': 'Mon',
  'scheduleSettings.tuesday': 'Tue',
  'scheduleSettings.wednesday': 'Wed',
  'scheduleSettings.thursday': 'Thu',
  'scheduleSettings.friday': 'Fri',
  'scheduleSettings.saturday': 'Sat',
  'scheduleSettings.sunday': 'Sun',

  // ScheduleHistoryDrawer
  'scheduleHistory.title': 'Change History',
  'scheduleHistory.close': 'Close history panel',
  'scheduleHistory.noHistory': 'No change history yet',
  'scheduleHistory.loadingHistory': 'Loading history...',

  // ScheduleItemModalChecklistSection
  'checklistSection.completeMgmtCheck': 'Complete Management Check',
  'checklistSection.completeSubCheck': 'Complete Subcontractor Check',

  // EditProject hardcoded strings
  'editProject.projectNotFound': 'Project not found.',
  'editProject.failedToSave': 'Failed to save changes.',

  // NewProject additional hardcoded strings
  'newProject.scheduleSetupDesc': 'Choose how the schedule and checklist should be created for this project',
  'newProject.copyDevTemplate': 'Copy the 156-item Development template into this project',
  'newProject.copyRenovationTemplate': 'Copy the default Renovation schedule template into this project',
  'newProject.copyActiveTemplate': 'Copy an active template for this project type',
  'newProject.includeDependencyLinksDesc': 'Copy predecessor / successor relationships from the template',
  'newProject.generateTimelineDesc': 'Set start dates for all schedule items based on a start date',
  'newProject.paymentScheduleDesc': 'Optional — set up payment milestones. Editable later.',
  'newProject.projectNamePreview': 'Project Name',
  'newProject.siteAddressPreview': 'Site Address',

  // StageProgress
  'stageProgress.sitePlaceholder': "Describe what's happening on site...",
  'stageProgress.stagePhotos': 'Stage Photos',
  'stageProgress.upload': 'Upload',
  'stageProgress.stageUpdates': 'Stage Updates',
  'stageProgress.postUpdate': 'Post Stage Update',
  'stageProgress.postUpdateBtn': 'Post Update',
  'stageProgress.addPhotos': 'Add Photos',
  'stageProgress.stageProgress': 'Stage progress',
  'stageProgress.photos': 'photos',
  'stageProgress.updates': 'updates',
  'stageProgress.morePhotos': '+{n} more',
  'stageProgress.subcontractorReport': 'Subcontractor Report',
  'stageProgress.managementUpdate': 'Management Update',

  // FileRow
  'fileRow.moveToFolder': 'Move to folder',
  'fileRow.unhide': 'Unhide',
  'fileRow.hide': 'Hide',
  'fileRow.delete': 'Delete',
  'fileRow.noFolder': 'No folder',
  'fileRow.deleteFile': 'Delete this file?',
  'fileRow.deleteConfirm': 'Are you sure you want to delete this file?',
  'fileRow.cancel': 'Cancel',
  'fileRow.hidden': 'Hidden',

  // ScheduleChangeLogPanel
  'changeLog.noChanges': 'No schedule changes recorded yet.',
  'changeLog.noMatchFilter': 'No changes match this filter.',
  'changeLog.filterAll': 'All',
  'changeLog.filterDateChanges': 'Date Changes',
  'changeLog.filterDelays': 'Delays',
  'changeLog.filterClientVisible': 'Client Visible',
  'changeLog.filterCriticalPath': 'Critical Path',
  'changeLog.filterCompletion': 'Completion',
  'changeLog.clientVisible': 'Client visible',
  'changeLog.reason': 'Reason',
  'changeLog.linkedItemsRecalculated': '{n} linked item{plural} recalculated',

  // ScheduleClientView
  'clientView.loadingSchedule': 'Loading schedule...',
  'clientView.scheduleComingSoon': 'Schedule coming soon',
  'clientView.scheduleComingSoonDesc': 'Japan Homes is setting up the project schedule. It will appear here once ready.',
  'clientView.stageProgress': 'Stage Progress',
  'clientView.constructionMilestones': 'Construction Milestones',
  'clientView.overallProgress': 'Overall Progress',
  'clientView.stagesCompleted': '{completed}/{total} stages completed',
  'clientView.expectedCompletion': 'Expected completion',
  'clientView.currentStage': 'Current Stage',
  'clientView.projectComplete': 'Project complete',
  'clientView.nextStage': 'Next Stage',
  'clientView.estCompletion': 'Est. Completion',
  'clientView.original': 'Original',
  'clientView.scheduleUpdate': 'Schedule Update',
  'clientView.keyScheduleItems': 'Key Schedule Items',
  'clientView.upcomingWork': 'Upcoming Work',
  'clientView.recentlyCompleted': 'Recently Completed',
  'clientView.starts': 'Starts',
  'clientView.done': 'Done',
  'clientView.scheduleLegend': 'Schedule Legend',
  'clientView.legendCompleted': 'Completed',
  'clientView.legendCurrent': 'Current',
  'clientView.legendUpcoming': 'Upcoming',
  'clientView.scheduleNote': 'This is the planned schedule for your project. Japan Homes will keep you updated on any changes. Contact Japan Homes if you have any questions about dates or progress.',
  'clientView.expectedStart': 'Expected Start',
  'clientView.expectedEnd': 'Expected End',
  'clientView.duration': 'Duration',
  'clientView.workingDays': 'working days',
  'clientView.progress': 'Progress',
  'clientView.linkedStages': 'Linked Stages',
  'clientView.previous': 'Previous',
  'clientView.next': 'Next',
  'clientView.update': 'Update',
  'clientView.notes': 'Notes',
  'clientView.close': 'Close',
  'clientView.completed': 'Completed',
  'clientView.upcoming': 'Upcoming',
  'clientView.paymentPercent': '{n}% payment',

  // ScheduleGanttEditModal
  'ganttEdit.moveItem': 'Move schedule item?',
  'ganttEdit.resizeItem': 'Resize schedule item?',
  'ganttEdit.moving': 'moving',
  'ganttEdit.shiftingStart': 'shifting the start of',
  'ganttEdit.changingDuration': 'changing the duration of',
  'ganttEdit.currentStart': 'Current start',
  'ganttEdit.currentEnd': 'Current end',
  'ganttEdit.newStart': 'New start',
  'ganttEdit.newEnd': 'New end',
  'ganttEdit.duration': 'Duration',
  'ganttEdit.workingDays': 'working days',
  'ganttEdit.hasSuccessors': 'This item has {n} linked successor{plural}.',
  'ganttEdit.downstreamAffected': '{n} downstream item{plural} could be affected.',
  'ganttEdit.someComplete': 'Some affected linked items are already complete.',
  'ganttEdit.recalcDownstream': 'Recalculate all downstream items',
  'ganttEdit.itemComplete': 'This schedule item is marked complete. Are you sure you want to change its dates?',
  'ganttEdit.manualLock': 'This item has manual date lock. It will remain locked after the change.',
  'ganttEdit.saveAndUpdate': 'Save and update linked items',
  'ganttEdit.saveOnly': 'Save this item only',
  'ganttEdit.save': 'Save',
  'ganttEdit.cancel': 'Cancel',

  // ScheduleListView hardcoded strings
  'listView.allComplete': 'All {n} items complete',
  'listView.notMappedComplete': '{n} not mapped but complete',
  'listView.pendingFinal': 'pending final',
  'listView.noMappingIncomplete': 'no mapping + incomplete',
  'listView.incompleteChecklist': 'incomplete checklist',
  'listView.mappedButComplete': 'mapped but complete',
  'listView.notMappedReason': 'Not mapped — click Mark Complete',
  'listView.pendingFinalReason': 'Pending Final — click Mark Complete',
  'listView.inProgress': 'In progress ({pct}%)',
  'listView.checklistIncomplete': 'Checklist incomplete',
  'listView.noChecklistLinked': 'This schedule item has no linked checklist. To reach 100% automatically, map checklist items to this schedule item. Or mark it complete manually.',
  'listView.linkedChecklistIncomplete': 'Linked checklist items are not fully approved. Complete all required management and subcontractor checks to unlock automatic completion.',
  'listView.progressLabel': 'Progress',
  'listView.checklistItems': 'checklist items',
  'listView.progressDerivedFromChecklist': 'Progress is derived from linked checklist completion.',
  'listView.noChecklistLinkedManual': 'No checklist linked. Progress is set manually.',
  'listView.start': 'Start',
  'listView.end': 'End',
  'listView.duration': 'Duration',
  'listView.workingDays': 'working days',
  'listView.assigned': 'Assigned',
  'listView.checklistCompletion': 'Checklist Completion',
  'listView.mgmt': 'Mgmt',
  'listView.sub': 'Sub',
  'listView.mgmtPending': 'mgmt pending',
  'listView.subPending': 'sub pending',
  'listView.linkedChecklistItems': 'Linked Checklist Items',
  'listView.baselineStart': 'Baseline Start',
  'listView.baselineEnd': 'Baseline End',
  'listView.criticalPath': 'Critical Path',
  'listView.criticalPathYes': 'Yes — delays affect completion',
  'listView.delay': 'Delay',
  'listView.delayDays': '{n} day{plural}',
  'listView.dependencies': 'Dependencies',
  'listView.remove': 'Remove',
  'listView.editItem': 'Edit item',
  'listView.addLink': 'Add link',
  'listView.sendInstruction': 'Send Instruction',
  'listView.deleteItem': 'Delete',
  'listView.blockingProgress': 'Blocking Progress',
  'listView.notMapped': 'Not mapped',
  'listView.manualComplete': 'Manual complete',
  'listView.noChecklist': 'No checklist',
  'listView.waitingForSub': 'Waiting for Sub',
  'listView.finalComplete': 'Final: Complete',
  'listView.markComplete': 'Mark Complete',
  'listView.completed': 'Completed',
  'listView.incomplete': 'Incomplete',

  // ScheduleGanttView hardcoded strings
  'ganttView.useWeekView': 'Use Day or Week view for precise date editing',
  'ganttView.includeAll': 'Include all items',
  'ganttView.excludeAll': 'Exclude all items',
  'ganttView.criticalPath': 'Critical path',
  'ganttView.excluded': 'excl',
  'ganttView.final': 'Final',
  'ganttView.done': 'Done',
  'ganttView.complete': 'Complete',
  'ganttView.today': 'Today',
  'ganttView.excluded2': 'Excluded',
  'ganttView.noDateAssigned': 'No date assigned',
  'ganttView.hiddenLink': 'hidden link',
  'ganttView.criticalPathNotCalc': 'Critical path has not been calculated yet',
  'ganttView.criticalPathDesc': 'The critical path identifies the sequence of tasks that directly impacts your project timeline.',
  'ganttView.calculateCriticalPath': 'Calculate Critical Path',

  // ScheduleToolbar hardcoded strings
  'toolbar.list': 'List',
  'toolbar.gantt': 'Gantt',
  'toolbar.day': 'Day',
  'toolbar.week': 'Week',
  'toolbar.month': 'Month',
  'toolbar.year': 'Year',
  'toolbar.wideZoom': 'Wide',
  'toolbar.comfortableZoom': 'Comfortable',
  'toolbar.compactZoom': 'Compact',
  'toolbar.miniZoom': 'Mini',
  'toolbar.today': 'Today',
  'toolbar.regenerate': 'Regenerate',
  'toolbar.importPdf': 'Import PDF',
  'toolbar.filter': 'Filter',
  'toolbar.filterActive': 'Filter Active',
  'toolbar.phases': 'Phases',
  'toolbar.critical': 'Critical',
  'toolbar.enableCritical': 'Enable Critical',
  'toolbar.fullscreen': 'Fullscreen',
  'toolbar.exit': 'Exit',
  'toolbar.more': 'More',
  'toolbar.allStages': 'All Stages',
  'toolbar.allSubStages': 'All Sub-Stages',
  'toolbar.clearStageFilters': 'Clear stage filters',
  'toolbar.statusAll': 'All',
  'toolbar.statusPending': 'Pending Final',
  'toolbar.statusDone': 'Final 100%',
  'toolbar.statusNoCL': 'No Checklist',
  'toolbar.statusIncCL': 'Incomplete CL',
  'toolbar.statusPendingMobile': 'Pending',
  'toolbar.statusDoneMobile': 'Done',
  'toolbar.statusNoCLMobile': 'No CL',
  'toolbar.statusIncCLMobile': 'Inc. CL',
  'toolbar.statusLabel': 'Status',
  'toolbar.selected': 'selected',
  'toolbar.selectAll': 'Select all visible',
  'toolbar.selectAllMobile': 'All',
  'toolbar.clear': 'Clear',
  'toolbar.markAllPending': 'Mark All Pending',
  'toolbar.markSelected': 'Mark Selected',
  'toolbar.markAllPendingMobile': 'All',
  'toolbar.completeMobile': 'Complete',
  'toolbar.pendingItems': '{n} item{plural} pending',
  'toolbar.scheduleOnline': 'Schedule Online',
  'toolbar.comingSoon': 'Coming soon',
  'toolbar.exportPdfCsv': 'Export to PDF / CSV',
  'toolbar.scheduleHistory': 'Schedule History',
  'toolbar.addScheduleItem': 'Add Schedule Item',
  'toolbar.hideAllLinks': 'Hide all links',
  'toolbar.showAllLinks': 'Show all links',
  'toolbar.visibility': 'Visibility',
  'toolbar.hideExcluded': 'Hide excluded items',
  'toolbar.showExcluded': 'Show excluded items',
  'toolbar.includeAll': 'Include all {n} items',
  'toolbar.excludeAll': 'Exclude all items',
  'toolbar.actions': 'Actions',
  'toolbar.regenerateTimeline': 'Regenerate Timeline',
  'toolbar.createTimeline': 'Create Timeline',
  'toolbar.importBuildertrend': 'Import Buildertrend PDF',
  'toolbar.recalcProgress': 'Recalculate Progress',
  'toolbar.recalcCriticalPath': 'Recalculate Critical Path',
  'toolbar.recalcLinkedItems': 'Recalculate Linked Items',
  'toolbar.setBaseline': 'Set Baseline',
  'toolbar.resetCriticalPath': 'Reset Critical Path Flags',
  'toolbar.debugInfo': 'Debug Info',
  'toolbar.hideSummary': 'Hide Summary',
  'toolbar.showSummary': 'Show Summary',
  'toolbar.hideLinks': 'Hide links',
  'toolbar.showLinks': 'Show links',
  'toolbar.hidePhases': 'Hide phases',
  'toolbar.showPhases': 'Show phases',
  'toolbar.allItems': 'All items',
  'toolbar.criticalPathOnly': 'Critical path',
  'toolbar.hideExcludedMobile': 'Hide excluded',
  'toolbar.showExcludedMobile': 'Show excluded',
  'toolbar.refresh': 'Refresh',
  'toolbar.addItem': 'Add item',
  'toolbar.clearFilter': 'Clear',
  'toolbar.marking': 'Marking...',
  'toolbar.markAllPendingComplete': 'Mark All Pending Complete',
  'toolbar.copyGanttColors': 'Copy Gantt Colors from 5 Methuen Road',

  // Copy Gantt Colors modal
  'schedule.copyColorsConfirmTitle': 'Copy Gantt Colors from 5 Methuen Road?',
  'schedule.copyColorsConfirmDesc': 'This will copy Gantt bar colors from 5 Methuen Road to this project by matching task number, title, or schedule order. Only bar_color will change — dates, progress, and completion status will not be affected.',
  'schedule.copyColorsWarningText': 'Any existing custom bar colors on this project will be overwritten.',
  'schedule.copyColorsBtn': 'Copy Colors',
  'schedule.copyingColorsLabel': 'Copying...',
  'schedule.dismissResult': 'Dismiss',
  'files.newFileUploaded': 'New file uploaded',

  // PaymentsTab notification
  'payments.mgmtConfirmedReceipt': 'Management has confirmed receipt of your payment.',

  // PhotosTab notifications
  'photos.newPhotosAdded': 'New project photos have been added to the gallery.',
  'photos.newPhotosAddedClient': 'New project photos have been added to your project gallery.',
  'photos.photoNotFound': 'Photo not found',
  'photos.deleteFailed': 'Delete failed',

  // TasksTab notification
  'tasks.clientMarkedPaid': 'Client has marked this payment as paid.',
  'tasks.mgmtConfirmedReceipt': 'Management has confirmed receipt of your payment.',

  // Date locale
  'date.locale': 'en-NZ',
  'date.localeShort': 'en',

  // Change Orders module
  'nav.changeOrders': 'Change Orders',
  'nav.scheduleTemplates': 'Schedule Templates',
  'templates.pageTitle': 'Schedule Template Management',
  'templates.pageDesc': 'Manage Development and Renovation schedule templates used when creating new projects.',
  'templates.pageDescMulti': 'Create and manage multiple schedule templates per project type. Changes apply to new projects only.',
  'templates.createTemplate': 'New template',
  'templates.create': 'Create',
  'templates.filterAll': 'All types',
  'templates.emptyList': 'No schedule templates yet.',
  'templates.emptyListHint': 'Create a template to define schedule patterns for new projects.',
  'templates.emptyFilter': 'No templates match this project type filter.',
  'templates.untitledTemplate': 'Untitled template',
  'templates.defaultBadge': 'Default',
  'templates.draftBadge': 'Draft',
  'templates.activeBadge': 'Active',
  'templates.itemCount': '{count} tasks',
  'templates.linkCount': '{count} links',
  'templates.updatedAt': 'Updated {date}',
  'templates.edit': 'Edit',
  'templates.duplicate': 'Duplicate',
  'templates.exportCsv': 'Export CSV',
  'templates.setDefault': 'Set as default',
  'templates.archive': 'Archive',
  'templates.delete': 'Delete',
  'templates.importCsv': 'Import CSV',
  'templates.importComingSoon': 'CSV import will be available in a future update.',
  'templates.duplicatePrompt': 'Name for the duplicated template',
  'templates.duplicated': 'Template duplicated.',
  'templates.defaultSet': 'Default template updated.',
  'templates.archiveConfirm': 'Archive "{name}"? It will be hidden from new projects.',
  'templates.archived': 'Template archived.',
  'templates.archiveDisabledDefault': 'This is the default {projectType} template. Create another {projectType} template and set it as default before archiving.',
  'templates.archiveDisabledDefaultWithTasks': 'This is the default {projectType} template. Set another {projectType} template as default before archiving.',
  'templates.archiveDisabledEmptyDefault': 'This empty template is marked as default. Add tasks, set another template as default, or delete it if unused.',
  'templates.archiveDisabledOnlyTemplate': 'Create another {projectType} template and set it as default before archiving this one.',
  'templates.draftHelp': 'Draft templates are not used for new projects until they contain tasks and are set as default.',
  'templates.setDefaultNeedsTasks': 'Add at least one task before setting this template as default.',
  'templates.deleteEmptyConfirm': 'Delete this empty template? This cannot be undone.',
  'templates.createdAsDraft': 'Template created as draft. Add tasks before using as default.',
  'templates.savedAsDraft': 'Saved as draft. Add tasks before using as default.',
  'templates.deleteConfirm': 'Permanently delete "{name}"? This cannot be undone.',
  'templates.deleted': 'Template deleted.',
  'templates.created': 'Template created.',
  'templates.newTemplateNamePlaceholder': 'e.g. Development B Pattern',
  'templates.saved': 'Template saved.',
  'templates.saving': 'Saving…',
  'templates.searchItems': 'Search tasks…',
  'templates.noSearchResults': 'No tasks match your search.',
  'templates.sortOrder': 'Order',
  'templates.developmentTemplate': 'Development Template',
  'templates.developmentTemplateDesc': 'Default Buildertrend-based development schedule template.',
  'templates.renovationTemplate': 'Renovation Template',
  'templates.renovationTemplateDesc': 'Default renovation schedule template.',
  'templates.editorPending': 'Template editing will be managed here.',
  'templates.editorTitleDevelopment': 'Development Schedule Template',
  'templates.editorTitleRenovation': 'Renovation Schedule Template',
  'templates.templateName': 'Template name',
  'templates.templateType': 'Template type',
  'templates.stagesTasksList': 'Stages / tasks',
  'templates.addStageTask': 'Add stage / task',
  'templates.editStageTask': 'Edit',
  'templates.deleteStageTask': 'Delete',
  'templates.applyEdit': 'Apply',
  'templates.taskTitle': 'Task title',
  'templates.phase': 'Phase / stage',
  'templates.durationDays': 'Duration (days)',
  'templates.days': 'days',
  'templates.untitledTask': 'Untitled task',
  'templates.noItems': 'No stages or tasks in this template yet.',
  'templates.loading': 'Loading template…',
  'templates.loadError': 'Failed to load template',
  'templates.saveNotConnected': 'Save function is not connected yet',
  'templates.templateLinksHeading': 'Template links ({count})',
  'templates.addLink': 'Add link',
  'templates.searchLinks': 'Search links by task name…',
  'templates.predecessor': 'Predecessor',
  'templates.successor': 'Successor',
  'templates.chooseTask': 'Choose task…',
  'templates.lagDays': 'Lag days',
  'templates.addDependency': 'Add dependency',
  'templates.linksNeedTwoTasks': 'Save at least two template tasks before creating dependency links.',
  'templates.noLinksYet': 'No template links yet.',
  'templates.noLinkSearchResults': 'No links match your search.',
  'templates.linkCountBadge': '{count} links',
  'templates.unknownTask': 'Unknown task',
  'templates.ganttView': 'Gantt view',
  'templates.listView': 'List view',
  'templates.linkTypeLabel': 'Type',
  'templates.lagLabel': 'Lag',
  'templates.predecessorLinks': 'Predecessors',
  'templates.successorLinks': 'Successors',
  'templates.noPredecessorLinks': 'No predecessor links for this task.',
  'templates.noSuccessorLinks': 'No successor links for this task.',
  'templates.ganttSyntheticHint': 'Synthetic timeline (Day 1, Day 2…) from task order, duration, and dependency links.',
  'templates.ganttSelectTask': 'Click a task bar to inspect and edit its links.',
  'templates.ganttSelectedTask': 'Selected task',
  'templates.ganttAddSuccessor': 'Add successor link',
  'templates.ganttAddPredecessor': 'Add predecessor link',
  'templates.ganttLinkCounts': 'in/out links',
  'templates.templateGanttComingSoon': 'Template Gantt view coming next. Use the grouped link editor for now.',
  'newProject.selectScheduleTemplate': 'Schedule template',
  'newProject.renovationScheduleMode': 'Renovation schedule',
  'newProject.renovationModeLight': 'Light schedule (11 tasks)',
  'newProject.renovationModeTemplate': 'Full template from library',
  'newProject.renovationModeBlank': 'Blank / manual',
  'newProject.renovationModeBlankDesc': 'No schedule tasks will be created. Add tasks manually from the Schedule tab after creation.',
  'newProject.tasksLabel': 'tasks',
  'co.pageTitle': 'Change Orders',
  'co.pageSubtitle': 'Track scope changes requiring client or subcontractor approval',
  'co.create': 'New Change Order',
  'co.items': 'items',
  'co.readMore': 'Read more',
  'co.showLess': 'Show less',
  'co.clientComment': 'Client Comment',
  'co.viewInProject': 'View in Project',
  'co.lockedTooltip': 'This change order is locked (approved/closed)',
  'co.lockedMessage': 'Locked — approved or closed records cannot be edited. Create a new Change Order to revise.',
  // Status labels
  'co.status.draft': 'Draft',
  'co.status.pendingApproval': 'Pending Approval',
  'co.status.sentToClient': 'Pending Approval',
  'co.status.approved': 'Approved',
  'co.status.clientApproved': 'Approved',
  'co.status.rejected': 'Rejected',
  'co.status.clientRejected': 'Rejected',
  'co.status.closed': 'Closed',
  'co.status.inProgress': 'In Progress',
  'co.status.completed': 'Completed',
  'co.status.cancelled': 'Cancelled',
  // Filter
  'co.filter.all': 'All',
  'co.filter.pendingClient': 'Pending Approval',
  'co.filter.approved': 'Approved',
  'co.filter.rejected': 'Rejected',
  'co.filter.draft': 'Draft',
  'co.filter.closed': 'Closed',
  'co.filter.inProgress': 'In Progress',
  'co.filter.completed': 'Completed',
  'co.filter.archived': 'Archived',
  'co.filter.noPricing': 'No pricing',
  // Stats
  'co.stats.total': 'Total',
  'co.stats.pendingClient': 'Pending Approval',
  'co.stats.approved': 'Approved',
  'co.stats.draft': 'Draft',
  // Alert
  'co.alert.pendingClientApproval': 'change order(s) awaiting client approval',
  'co.alert.pendingClientDesc': 'Client has been notified and is pending review.',
  // Badges
  'co.badge.clientApproval': 'Client Approval',
  'co.badge.clientApproved': 'Client Approved',
  'co.badge.clientDeclined': 'Client Declined',
  'co.clientPortal.visible': 'Visible to client',
  'co.clientPortal.autoVisible': 'Visible to client',
  'co.clientPortal.hidden': 'Hidden from client',
  'co.clientPortal.draft': 'Draft (hidden)',
  'co.clientPortal.shareWithClient': 'Share with client',
  'co.clientPortal.hideFromClient': 'Hide from client',
  'co.badge.noPricing': 'No pricing',
  // Details
  'co.details.title': 'Change Order Details',
  'co.details.reason': 'Reason:',
  'co.details.currentFinish': 'Current:',
  'co.details.newFinish': 'New:',
  'co.details.costImpact': 'Cost:',
  'co.details.scheduleImpact': 'Schedule:',
  // Actions
  'co.action.sendToClient': 'Send to Client',
  'co.action.markApproved': 'Mark Approved',
  'co.action.markRejected': 'Mark Rejected',
  'co.action.markCompleted': 'Mark Completed',
  'co.action.close': 'Close',
  'co.action.cancel': 'Cancel',
  'co.action.edit': 'Edit Change Order',
  'co.action.revertToDraft': 'Revert to Draft',
  'co.action.archive': 'Archive',
  'co.action.delete': 'Delete',
  'co.action.editCoNumber': 'Edit CO number',
  'co.action.cancelConfirm': 'Cancel',
  'co.confirmArchiveTitle': 'Archive change order?',
  'co.confirmArchiveApproved': 'This approved change order will be archived and hidden from the client portal. Attachments are not deleted.',
  'co.confirmArchiveDefault': 'This change order will be archived (status set to cancelled) and hidden from the normal list.',
  'co.confirmDeleteTitle': 'Delete change order?',
  'co.confirmDeleteDefault': 'Delete this Change Order? This cannot be undone.',
  'co.confirmDeleteStrongWarning': 'This Change Order has pricing or approval history. Are you sure you want to delete it?',
  'co.confirmDeleteDraft': 'This draft change order will be permanently deleted.',
  'co.archivedMessage': 'Change order archived.',
  'co.archivedApprovedMessage': 'Approved change order archived and hidden from client portal.',
  'co.deletedMessage': 'Change order deleted.',
  'co.coNumberUpdated': 'CO number updated to {number}.',
  'co.editCoNumberTitle': 'Edit CO number',
  'co.editCoNumberDesc': 'Update the change order number to match Buildertrend or your project register. Only the CO number can be changed on approved orders.',
  'co.form.coNumberLabel': 'CO number',
  'co.saveCoNumber': 'Save CO number',
  'co.saving': 'Saving…',
  // Internal section (management only)
  'co.internal.title': 'Internal — Not Visible to Client',
  'co.internal.builderCost': 'Builder Cost',
  'co.internal.clientPrice': 'Client Price',
  'co.internal.margin': 'Margin',
  // Client-visible description
  'co.clientDesc.label': 'Client Description',
  // Form
  'co.form.createTitle': 'New Change Order',
  'co.form.editTitle': 'Edit Change Order',
  'co.form.titleLabel': 'Title',
  'co.form.titlePlaceholder': 'e.g. Kitchen tile upgrade',
  'co.form.descriptionLabel': 'Internal Description',
  'co.form.descriptionPlaceholder': 'Internal notes about this change (not visible to client)...',
  'co.form.clientDescLabel': 'Client Description',
  'co.form.clientDescPlaceholder': 'Description shown to client...',
  'co.form.reasonLabel': 'Reason for Change',
  'co.form.reasonPlaceholder': 'e.g. Client requested upgrade',
  'co.form.currentFinishLabel': 'Current Finish/Spec',
  'co.form.currentFinishPlaceholder': 'e.g. Standard 300x300 tiles',
  'co.form.newFinishLabel': 'New Finish/Spec',
  'co.form.newFinishPlaceholder': 'e.g. 600x600 porcelain',
  'co.form.scheduleImpactLabel': 'Schedule Impact',
  'co.form.scheduleImpactPlaceholder': 'e.g. +3 working days',
  'co.form.builderCostLabel': 'Builder Cost (NZD)',
  'co.form.clientPriceLabel': 'Client Price (NZD)',
  'co.form.internalNoteLabel': 'Internal Note',
  'co.form.internalNotePlaceholder': 'PM-only notes (supplier, margin notes, etc.)...',
  'co.form.statusLabel': 'Status',
  'co.form.requiresClientApproval': 'Requires client approval',
  'co.form.internalOnly': 'internal only',
  'co.form.clientVisible': 'client visible',
  'co.form.saveChanges': 'Save Changes',
  'co.form.create': 'Create',
  // Empty
  'co.empty.title': 'No change orders yet',
  'co.empty.desc': 'Change orders are used to document scope, specification, or cost changes.',
  'tabs.changeOrders': 'Change Orders',

  // ── Layout additions (Client / Subcontractor) ──
  'nav.myProject': 'My Project',
  'nav.payments': 'Payments',
  'nav.questions': 'Questions',
  'role.clientPortal': 'Client Portal',
  'role.subcontractor': 'Subcontractor',
  'user.client': 'Client',
  'user.subcontractor': 'Subcontractor',

  // ── Relative time (weeks) ──
  'notifications.weekAgo': '{n} week ago',
  'notifications.weeksAgo': '{n} weeks ago',

  // ── Notification type translations (title prefix + body) ──
  'notif.type.daily_log_created': 'New Daily Log',
  'notif.type.instruction_created': 'New instruction',
  'notif.type.change_order_approved': 'Client approved {title} of change order',
  'notif.type.schedule_recalculated': 'Schedule recalculated',
  'notif.type.critical_path_delayed': 'Critical path item delayed: {title}',
  'notif.type.payment_confirmed': 'Payment confirmed',
  'notif.type.photo_uploaded': 'New photos uploaded',
  'notif.type.file_uploaded': 'New file uploaded',
  'notif.type.question_asked': 'New question',
  'notif.type.update_posted': 'New update posted',
  'notif.type.task_created': 'New task',
  'notif.type.checklist_updated': 'Checklist updated',

  // ── Notification body translations ──
  'notif.body.schedule_recalculated': 'has linked schedule items recalculated based on dependency changes.',
  'notif.body.critical_path_delayed': 'now delayed. Expected completion {date}.',
  'notif.body.change_order_approved': 'Client approved the change order.',
  'notif.body.payment_confirmed': 'Management has confirmed receipt of your payment.',
  'notif.body.client_marked_paid': 'Client has marked this payment as paid.',

  // ── Empty states (Part 6) ──
  'checklist.noChecklistItemsEmpty': 'No checklist items',
  'checklist.createDefaultForProject': 'Create default checklist for this project',
  'story.noEventsYet': 'No story events yet',
  'story.addEvent': 'Add Event',
  'schedule.generateInitialTimelineBtn2': 'Generate initial timeline',
  'schedule.hideDetailsBtn2': 'Hide details',
  'schedule.showDetailsBtn2': 'Show details',
  'schedule.markAllPendingCompleteBtn': 'Mark all pending schedule items complete',
  'schedule.reviewPendingItemsBtn2': 'Review pending items',
  'schedule.noChecklistMappingLabel': 'No Checklist Mapping',
  'schedule.pendingScheduleItemsCount': '{count} schedule items pending',

  // ScheduleTab status summary
  'schedule.statusHideDetails': 'Hide details',
  'schedule.statusShowDetails': 'Show details',
  'schedule.notMappedCount': ' · {count} not mapped',

  // ScheduleGenerateModal
  'generateModal.title': 'Create / Regenerate Timeline',
  'generateModal.startDateLabel': 'Project Start Date',
  'generateModal.nonWorkingDayWarning': 'This date is a {day} (non-working). The first item will be shifted to the next working day automatically.',
  'generateModal.scopeLabel': 'Generate timeline for',
  'generateModal.scopeAll': 'All active schedule items',
  'generateModal.scopeAllDesc': '{count} included items will get dates.',
  'generateModal.scopeUnfinished': 'Unfinished active items only',
  'generateModal.scopeUnfinishedDesc': '{count} unfinished items will get dates. Completed items keep existing dates.',
  'generateModal.modeLabel': 'Regeneration Mode',
  'generateModal.modeFillEmpty': 'Fill only empty dates',
  'generateModal.modeFillEmptyDesc': 'Only assign dates to items that do not already have start and end dates.',
  'generateModal.modeOverwrite': 'Overwrite all schedule dates',
  'generateModal.modeOverwriteDesc': 'Replace existing start and end dates for all included schedule items.',
  'generateModal.modeOverwriteWarning': 'This will replace existing start and end dates for included schedule items. Progress and completion status will not be changed.',
  'generateModal.generating': 'Generating...',
  'generateModal.generateBtn': 'Generate Timeline',
  'generateModal.overwriteTitle': 'Overwrite Existing Dates?',
  'generateModal.overwriteDesc': 'Some schedule items already have dates assigned. This will replace all existing start and end dates for included items.',
  'generateModal.overwriteWarning': 'Progress and completion status will not be changed.',
  'generateModal.cancel': 'Cancel',
  'generateModal.overwriteGenerate': 'Overwrite & Generate',

  // ScheduleBaselineModal
  'baselineModal.baselineExists': 'Baseline Already Exists',
  'baselineModal.setBaseline': 'Set Baseline',
  'baselineModal.existsDesc': 'A baseline already exists for this project. Do you want to overwrite baseline dates and create a new snapshot, or just create a new snapshot?',
  'baselineModal.noBaselineDesc': 'Save current start and end dates as the baseline for all schedule items. This allows you to track schedule drift later.',
  'baselineModal.overwriteAndSnapshot': 'Overwrite baseline and create snapshot',
  'baselineModal.snapshotOnly': 'Create new snapshot only',
  'baselineModal.setBaselineBtn': 'Set Baseline',
  'baselineModal.cancel': 'Cancel',

  // ScheduleAlertsPanel
  'alertsPanel.alertCount': '{count} Schedule Alert',
  'alertsPanel.alertCountPlural': '{count} Schedule Alerts',
  'alertsPanel.filterAll': 'All',
  'alertsPanel.filterCriticalDelayed': 'Critical Delayed',
  'alertsPanel.filterAtRisk': 'At Risk',
  'alertsPanel.filterBehind': 'Behind',
  'alertsPanel.moreHidden': '{count} more alerts hidden',

  // ScheduleSummaryCards
  'summaryCards.projectCompletion': 'Project Completion',
  'summaryCards.baselineCompletion': 'Baseline Completion',
  'summaryCards.noBaseline': 'No baseline',
  'summaryCards.scheduleVariance': 'Schedule Variance',
  'summaryCards.behindDays': '+{n}d behind',
  'summaryCards.aheadDays': '{n}d ahead',
  'summaryCards.onBaseline': '0 days on baseline',
  'summaryCards.criticalItems': 'Critical Items',
  'summaryCards.onCriticalPath': 'on critical path',
  'summaryCards.delayedItems': 'Delayed Items',
  'summaryCards.behindSchedule': 'behind schedule',
  'summaryCards.atRiskItems': 'At Risk Items',
  'summaryCards.dueWithin3Days': 'due within 3 days',
  'summaryCards.scheduleStatus': 'Schedule Status',
  'summaryCards.scheduleHealth': 'Schedule Health',

  // ScheduleSubcontractorView
  'subView.projectSchedule': 'Project Schedule',
  'subView.scheduleItemsCount': '{count} schedule items · read-only view',
  'subView.mySchedule': 'My Schedule',
  'subView.fullProject': 'Full Project',
  'subView.cards': 'Cards',
  'subView.gantt': 'Gantt',
  'subView.stageContext': 'Stage Context',
  'subView.noAssigned': 'No items assigned to you yet',
  'subView.noAssignedDesc': 'No schedule items are currently assigned to your company. Showing full project schedule.',
  'subView.readOnly': 'Read-only view. Contact management to update schedule dates.',
  'subView.noScheduleYet': 'No schedule yet',
  'subView.noScheduleYetDesc': "The project schedule hasn't been set up yet. Check back soon.",
  'subView.noItemsToDisplay': 'No schedule items to display.',
  'subView.delayedAttention': 'Delayed / Attention Required',
  'subView.thisWeek': 'This Week',
  'subView.nextTwoWeeks': 'Next 2 Weeks',
  'subView.upcomingWork': 'Upcoming Work',
  'subView.workingDays': 'working days',
  'subView.progress': 'Progress',
  'subView.linkedStages': 'Linked Stages',
  'subView.notes': 'Notes',
  'subView.close': 'Close',
  'subView.start': 'Start',
  'subView.end': 'End',
  'subView.duration': 'Duration',
  'subView.delayed': 'Delayed',
  'subView.atRisk': 'At Risk',
  'subView.onTrack': 'On Track',
  'subView.comingUp': 'Coming Up',
  'subView.dueSoon': 'Due Soon',
  'subView.attentionNeeded': 'Attention Needed',
  'subView.completed': 'Completed',

  // ScheduleExportPanel
  'exportPanel.title': 'Export Schedule',
  'exportPanel.exportToPDF': 'Export to PDF',
  'exportPanel.exportToPDFDesc': 'Open Gantt chart print dialog to save as PDF',
  'exportPanel.exportToCSV': 'Export to CSV',
  'exportPanel.exportToCSVDesc': 'Download schedule as spreadsheet',
  'exportPanel.print': 'Print Schedule',
  'exportPanel.printDesc': 'Print the Gantt chart with task bars and timeline',
  'exportPanel.note': 'Print and PDF export open a dedicated Gantt layout in a new window. CSV export downloads task data only.',
  'exportPanel.csvSuccess': 'CSV exported successfully',
  'exportPanel.csvFailed': 'CSV export failed. Please try again.',
  'exportPanel.printSuccess': 'Gantt print preview opened.',
  'exportPanel.printFailed': 'Gantt print failed. Please try again.',
  'exportPanel.pdfSuccess': 'Gantt PDF export opened. Choose Save as PDF in the print dialog.',
  'exportPanel.pdfFailed': 'PDF export failed. Please try again.',
  'exportPanel.popupBlocked': 'Popup blocked. Please allow popups and try again.',
  'exportPanel.noPrintableItems': 'No included schedule tasks to export or print.',

  // BuildertrendImportModal
  'btImport.title': 'Import Buildertrend Schedule',
  'btImport.itemsFromPDF': '{count} items from PDF',
  'btImport.filterAll': 'All',
  'btImport.filterChanges': 'Changes only',
  'btImport.filterNew': 'New items',
  'btImport.filterExact': 'Exact',
  'btImport.filterHigh': 'High',
  'btImport.filterMedium': 'Medium',
  'btImport.filterLow': 'Low',
  'btImport.filterNoMatch': 'No match',
  'btImport.selectAll': 'Select all',
  'btImport.deselectAll': 'Deselect all',
  'btImport.selectedOf': '{selected} selected · {withChanges} with changes',
  'btImport.willBeImported': '{selected} of {total} items will be imported',
  'btImport.noMatchFilter': 'No items match this filter.',
  'btImport.back': 'Back',
  'btImport.cancel': 'Cancel',
  'btImport.reviewConfirm': 'Review & Confirm',
  'btImport.saving': 'Saving…',
  'btImport.confirmImport': 'Confirm Import',
  'btImport.changes': 'Changes',
  'btImport.matched': 'Matched',
  'btImport.newItem': 'New item',
  'btImport.current': 'Current',
  'btImport.new': 'New',
  'btImport.color': 'Color',
  'btImport.reviewBeforeConfirm': 'Please review before confirming',
  'btImport.reviewDesc': 'This will update {update} existing schedule items and create {create} new items. Progress and completion status will not be changed.',
  'btImport.itemsToUpdate': 'Items to update ({count})',
  'btImport.newItemsToCreate': 'New items to create ({count})',
  'btImport.columnNo': '#',
  'btImport.columnPDFTitle': 'PDF Title',
  'btImport.columnMatchedItem': 'Matched Item',
  'btImport.columnOldStart': 'Old Start',
  'btImport.columnNewStart': 'New Start',
  'btImport.columnDuration': 'Duration',
  'btImport.columnColor': 'Color',
  'btImport.columnTitle': 'Title',
  'btImport.columnStart': 'Start',
  'btImport.columnEnd': 'End',
  'btImport.columnPhase': 'Phase',

  // ScheduleFilterChips
  'filterChips.all': 'All',
  'filterChips.criticalPath': 'Critical Path',
  'filterChips.delayed': 'Delayed',
  'filterChips.atRisk': 'At Risk',
  'filterChips.completed': 'Completed',
  'filterChips.excluded': 'Excluded',

  // StagesTab / SubStageCard
  'stagesCard.checksCount': '{checked}/{total} checks',
  'stagesCard.paymentPercent': '{n}% payment',
  'stagesCard.progressPct': '{pct}% progress',

  // ChecklistTab sub-stage check count
  'checklistSub.checksCount': '{completed}/{total} checks',
  'checklistSub.paymentPercent': '{n}% payment',

  // Status labels (Part 9)
  'status.open': 'Open',
  'status.overdue': 'Overdue',
  'status.upcoming': 'Upcoming',
  'status.published': 'Published',

  // Mobile-short CTA labels (used on small screens to prevent overflow)
  'mobile.markAllPendingComplete': 'Complete all pending',
  'mobile.createDefaultChecklist': 'Create default checklist',
  'mobile.reviewPendingItems': 'Review pending',
  'mobile.generateInitialTimeline': 'Generate timeline',
  'mobile.sendInstruction': 'Send Instruction',
  'mobile.createChangeOrder': 'Change Order',
  'mobile.assignSubcontractor': 'Assign Sub',
  'mobile.recalculateProgress': 'Recalculate',
  'mobile.createScheduleFromTemplate': 'Create schedule',
  'mobile.createDefaultChecklistForProject': 'Create checklist',
};



export default mgmt;